/* eslint-disable */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { usePaged, Pagination } from '../utils';
function toWA(p){const r=(p||'').replace(/\D/g,'');return r.startsWith('593')?r:r.startsWith('0')&&r.length===10?'593'+r.substring(1):r.length===9?'593'+r:r;}
import {
  Users, Phone, MessageCircle, Calendar, BarChart2, Trophy,
  XCircle, Clock, TrendingUp, AlertCircle, Activity,
  UserCheck, ChevronLeft, ChevronRight, Zap, Star, Download,
  RefreshCw, Eye, MessageSquare, CheckCircle, X,
  Video, Search, Send, FileText,
  Bell, Edit2, Trash2, Plus, DollarSign, Shield, Grid, Save,
  Flame, Thermometer, Snowflake, Target, Bot, FileSpreadsheet, ChevronDown,
  Gift, CreditCard, MapPin, Image} from 'lucide-react';
import { TabDashboard as InicioAdmin, TabPipelineAdmin, syncAdminTheme } from './DashboardAdmin';
const makeDS = (p = '#4f6ef7') => ({
  bg:'#f5f7fb', bg2:'#f8fafc', bg3:'#f1f5f9',
  surface:'#ffffff', surf2:'#f8fafc', surf3:'#f1f5f9',
  border:'1px solid #eaecf0', border2:'1.5px solid #e2e8f0',
  shadow:'0 1px 3px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.03)',
  shadow2:'0 4px 20px rgba(0,0,0,0.09)',
  glass:'rgba(0,0,0,0.02)', glass2:'#ffffff',
  text1:'var(--dark,#0f172a)', text2:'#475569', text3:'#94a3b8',
  red:'#ef4444', green:'#10b981', yellow:'#f59e0b',
  blue: p, primary: p,
  purple:'#8b5cf6',
  fontHead:"'DM Sans',sans-serif", fontBody:"'DM Sans',sans-serif",
});
let DS = makeDS();
let CB = '#ffffff'; // card background (updated per company)
let CBorder = '#4f6ef720'; // card border
let CShadow = '0 2px 12px #4f6ef714'; // card shadow
let MOB = false;
// Estilo de Inicio/Pipeline (admin) compartido; NAVY = "Color de textos" de superadmin
const NAVY = 'var(--dark,#0f172a)';
function PageHead({ title, sub, right }) {
  return (
    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-end', gap:12, flexWrap:'wrap', marginBottom:20, color:NAVY, fontFamily:"'DM Sans',sans-serif" }}>
      <div>
        <h1 style={{ margin:0, fontSize:MOB?22:28, fontWeight:800, letterSpacing:'-0.5px' }}>{title}</h1>
        {sub && <p style={{ margin:'4px 0 0', fontSize:14, color:'#64748b' }}>{sub}</p>}
      </div>
      {right}
    </div>
  );
}
let _setConfirmS = null;
let SUP = null; // usuario supervisor actual — para poder auto-asignarse clientes/leads
// asesores + el supervisor al inicio (backend /asesores no lo incluye)
const withSup = (asesores) => SUP?.id ? [{ id:SUP.id, name:SUP.name||'Supervisor' }, ...(asesores||[]).filter(x=>String(x.id)!==String(SUP.id))] : (asesores||[]);
function askConfirm(msg, onYes) { if (_setConfirmS) _setConfirmS({ msg, onYes }); }
function ConfirmModal({ msg, onYes, onClose }) {
  return (
    <div style={{position:'fixed',inset:0,background:'rgba(15,23,42,0.55)',backdropFilter:'blur(4px)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}} onClick={onClose}>
      <div style={{background:'#fff',borderRadius:20,padding:'28px 32px',width:340,boxShadow:'0 24px 64px rgba(0,0,0,0.18)',border:'1px solid #e2e8f0'}} onClick={e=>e.stopPropagation()}>
        <div style={{fontSize:18,fontWeight:800,color:'var(--dark,#0f172a)',marginBottom:8}}>¿Estás seguro?</div>
        <div style={{fontSize:13,color:'#64748b',marginBottom:24,lineHeight:1.6}}>{msg}</div>
        <div style={{display:'flex',gap:10}}>
          <button onClick={onClose} style={{flex:1,padding:'11px',borderRadius:10,border:'1px solid #e2e8f0',background:'#f8fafc',color:'#64748b',fontWeight:700,fontSize:13,cursor:'pointer'}}>No, cancelar</button>
          <button onClick={()=>{onYes();onClose();}} style={{flex:1,padding:'11px',borderRadius:10,border:'none',background:'#ef4444',color:'#fff',fontWeight:700,fontSize:13,cursor:'pointer'}}>Sí, eliminar</button>
        </div>
      </div>
    </div>
  );
}
const API = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace(/\/api\/?$/, '')
  : `${window.location.protocol}//${window.location.hostname}:3001`;
const tok = () => localStorage.getItem('crm_token');
// Abrir WhatsApp = cliente contactado: lo saca de los paneles "Sin contacto +24h"
// (asesor, supervisor y admin leen clients.last_contact).
const marcarContactado = phone => apiFetch('POST','/api/supervisor/contactado',{ phone }).catch(()=>{});

async function apiFetch(method, path, body) {
  const res = await fetch(`${API}${path}`, {
    method,
    headers: { 'Content-Type':'application/json', Authorization:`Bearer ${tok()}` },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Error');
  return data;
}

// Metas de venta — persisten en la BD (tabla sales_goals vía /api/supervisor/metas,
// compartida con el admin). Antes vivían solo en localStorage y admin/supervisor
// veían valores distintos.
function useMetas() {
  const [metas, setMetas]           = React.useState({});
  const [metaGlobal, setMetaGlobal] = React.useState(null);
  React.useEffect(() => {
    apiFetch('GET', '/api/supervisor/metas')
      .then(d => { setMetas(d.perAdvisor || {}); setMetaGlobal(d.global ?? null); })
      .catch(() => {});
  }, []);
  const saveMeta = async (advisorId, val) => {
    const target = parseInt(val) || 10;
    setMetas(m => ({ ...m, [advisorId]: target }));
    await apiFetch('PUT', '/api/supervisor/metas', { advisorId, target });
  };
  const saveMetaGlobal = async (val) => {
    const target = parseInt(val) || 0;
    setMetaGlobal(target);
    await apiFetch('PUT', '/api/supervisor/metas', { advisorId: null, target });
  };
  return { metas, metaGlobal, saveMeta, saveMetaGlobal };
}

const ago = d => { const s=(Date.now()-new Date(d))/1000; if(s<60)return 'ahora'; if(s<3600)return `${Math.floor(s/60)}m`; if(s<86400)return `${Math.floor(s/3600)}h`; return `${Math.floor(s/86400)}d`; };
const fmtT = s => `${String(Math.floor(s/60)).padStart(2,'0')}:${String(s%60).padStart(2,'0')}`;

/* ─────────────────────────── SHARED DATA ─────────────────────────── */
const ASESORES = [
  { id:'a1', name:'María García',  email:'maria@empresa.com',  phone:'+525550001111', active:true,  score:88, clients:12, won:4, lost:2, calls:28, avgDur:234, streak:5 },
  { id:'a2', name:'Carlos Ruiz',   email:'carlos@empresa.com', phone:'+525550002222', active:true,  score:62, clients:9,  won:2, lost:3, calls:17, avgDur:185, streak:1 },
  { id:'a3', name:'Ana Jiménez',   email:'ana@empresa.com',    phone:'+525550003333', active:false, score:94, clients:15, won:6, lost:1, calls:35, avgDur:278, streak:8 },
  { id:'a4', name:'Luis Mendoza',  email:'luis@empresa.com',   phone:'+525550004444', active:true,  score:48, clients:7,  won:1, lost:4, calls:12, avgDur:145, streak:0 },
];

const INIT_LEADS_SUP = [
  { id:'ls1', nombre:'Andrés Castillo', telefono:'+52551098765', email:'andres@gmail.com',    msgBot:'Vi su anuncio, me interesa el plan premium.',     nivel:'caliente', score:90, asesorId:'a1', asesor:'María García',  origen:'WhatsApp Bot', fecha:new Date(Date.now()-1*3600000).toISOString()  },
  { id:'ls2', nombre:'Patricia Núñez',  telefono:'+52339012345', email:'patricia@corp.mx',    msgBot:'¿Pueden enviarme información sobre sus planes?',  nivel:'caliente', score:82, asesorId:'a2', asesor:'Carlos Ruiz',   origen:'WhatsApp Bot', fecha:new Date(Date.now()-2*3600000).toISOString()  },
  { id:'ls3', nombre:'Fernando Reyes',  telefono:'+52554567890', email:'',                    msgBot:'Me recomendaron su empresa, quisiera cotización.', nivel:'caliente', score:78, asesorId:'a1', asesor:'María García',  origen:'WhatsApp Bot', fecha:new Date(Date.now()-4*3600000).toISOString()  },
  { id:'ls4', nombre:'Claudia Herrera', telefono:'+52813456789', email:'claudia@hotmail.com', msgBot:'¿Cuánto cuesta el plan básico?',                  nivel:'tibio',    score:55, asesorId:'a4', asesor:'Luis Mendoza',  origen:'WhatsApp Bot', fecha:new Date(Date.now()-6*3600000).toISOString()  },
  { id:'ls5', nombre:'Ricardo Méndez',  telefono:'+52556789012', email:'ricardo@empresa.com', msgBot:'Hola, quiero información general.',               nivel:'tibio',    score:50, asesorId:'a3', asesor:'Ana Jiménez',   origen:'WhatsApp Bot', fecha:new Date(Date.now()-8*3600000).toISOString()  },
  { id:'ls6', nombre:'Valentina Cruz',  telefono:'+52332345678', email:'',                    msgBot:'¿Tienen soporte en español?',                     nivel:'tibio',    score:42, asesorId:'a2', asesor:'Carlos Ruiz',   origen:'WhatsApp Bot', fecha:new Date(Date.now()-10*3600000).toISOString() },
  { id:'ls7', nombre:'Jorge Ponce',     telefono:'+52557890123', email:'',                    msgBot:'Ok',                                              nivel:'frio',     score:18, asesorId:'a4', asesor:'Luis Mendoza',  origen:'WhatsApp Bot', fecha:new Date(Date.now()-14*3600000).toISOString() },
  { id:'ls8', nombre:'Mónica Vargas',   telefono:'+52551234000', email:'',                    msgBot:'¿Esto es real o spam?',                           nivel:'frio',     score:12, asesorId:'a1', asesor:'María García',  origen:'WhatsApp Bot', fecha:new Date(Date.now()-18*3600000).toISOString() },
];
const LEAD_COLS_SUP = {
  caliente:{ label:'Caliente', sub:'Muy interesados',          color:'#ef4444', bg:'#fff5f5', border:'#fecaca' },
  tibio:   { label:'Tibio',   sub:'Medianamente interesado', color:'#f59e0b', bg:'#fffbeb', border:'#fde68a' },
  frio:    { label:'Frío',    sub:'Poco interés / poca info', color:'#4f6ef7', bg:'#f0f1ff', border:'#c7d2fe' },
};

const INIT_CLIENTS = [
  { id:'c1', name:'Roberto Sánchez', phone:'+52551234567', email:'roberto@gmail.com',  asesorId:'a1', asesor:'María García',  classification:'interested', result:null,   score:85, lossReason:null,  lastContact: new Date(Date.now()-2*3600000).toISOString(),   notes:'Interesado en plan premium' },
  { id:'c2', name:'Laura Martínez',  phone:'+52339876543', email:'laura@empresa.com',  asesorId:'a2', asesor:'Carlos Ruiz',   classification:'needs_info', result:null,   score:60, lossReason:null,  lastContact: new Date(Date.now()-26*3600000).toISOString(),  notes:'Solicita más info de precios' },
  { id:'c3', name:'Diego Ramírez',   phone:'+52815555444', email:null,                 asesorId:'a1', asesor:'María García',  classification:'interested', result:'won',  score:95, lossReason:null,  lastContact: new Date(Date.now()-5*3600000).toISOString(),   notes:'Cerrado exitosamente' },
  { id:'c4', name:'Sofía López',     phone:'+52557777888', email:'sofia@hotmail.com',  asesorId:'a4', asesor:'Luis Mendoza',  classification:'no_info',   result:'lost', score:20, lossReason:'Precio muy alto, optó por competencia',    lastContact: new Date(Date.now()-48*3600000).toISOString(),  notes:'No contestó 3 intentos' },
  { id:'c5', name:'Miguel Torres',   phone:'+52331122334', email:'miguel@corp.mx',     asesorId:'a3', asesor:'Ana Jiménez',   classification:'interested', result:null,   score:72, lossReason:null,  lastContact: new Date(Date.now()-4*3600000).toISOString(),   notes:'Reunión de cierre pendiente' },
  { id:'c6', name:'Carmen Vega',     phone:'+52554433221', email:'carmen@vega.mx',     asesorId:'a3', asesor:'Ana Jiménez',   classification:'needs_info', result:'won',  score:78, lossReason:null,  lastContact: new Date(Date.now()-6*3600000).toISOString(),   notes:'Cerrado en segunda llamada' },
  { id:'c7', name:'Pedro Flores',    phone:'+52559988776', email:'pedro@flores.mx',    asesorId:'a2', asesor:'Carlos Ruiz',   classification:'no_info',   result:'lost', score:15, lossReason:'No tiene presupuesto en este momento',     lastContact: new Date(Date.now()-72*3600000).toISOString(), notes:'Seguimiento en 3 meses' },
  { id:'c8', name:'Isabel Moreno',   phone:'+52553344556', email:'isabel@moreno.mx',   asesorId:'a4', asesor:'Luis Mendoza',  classification:'interested', result:null,   score:65, lossReason:null,  lastContact: new Date(Date.now()-8*3600000).toISOString(),   notes:'Evaluando opciones' },
];

const INIT_EVENTS = [
  { id:'e1', type:'cita',    title:'Demo producto',     clientId:'c1', clientName:'Roberto Sánchez', asesorId:'a1', asesor:'María García',  date: dateStr(2), time:'10:00', description:'Mostrar módulo de reportes y dashboard principal', done:false },
  { id:'e2', type:'llamada', title:'Seguimiento precio',clientId:'c2', clientName:'Laura Martínez',  asesorId:'a2', asesor:'Carlos Ruiz',   date: dateStr(1), time:'12:00', description:'Aclarar precios del plan empresarial',              done:false },
  { id:'e3', type:'cita',    title:'Cierre contrato',   clientId:'c5', clientName:'Miguel Torres',   asesorId:'a3', asesor:'Ana Jiménez',   date: dateStr(3), time:'15:00', description:'Reunión final para firma de contrato',              done:false },
  { id:'e4', type:'llamada', title:'Reactivación',      clientId:'c8', clientName:'Isabel Moreno',   asesorId:'a4', asesor:'Luis Mendoza',  date: dateStr(0), time:'09:00', description:'Llamada de seguimiento tras 8 días sin contacto',   done:true  },
];

const INIT_MESSAGES = [
  { id:'m1', from:'a1', fromName:'María García',  to:'sup', toName:'Supervisor', text:'Buenos días, ¿puedo hacer un descuento del 10% a Roberto?', time: new Date(Date.now()-30*60000).toISOString(), read:false },
  { id:'m2', from:'a2', fromName:'Carlos Ruiz',   to:'sup', toName:'Supervisor', text:'Laura pide más información técnica, ¿me ayudas con la ficha?', time: new Date(Date.now()-2*3600000).toISOString(), read:true  },
  { id:'m3', from:'sup',fromName:'Supervisor',    to:'a3', toName:'Ana Jiménez',  text:'Ana, excelente trabajo este mes. Sigue así!', time: new Date(Date.now()-4*3600000).toISOString(), read:true  },
];

function dateStr(daysAhead) {
  const d = new Date(); d.setDate(d.getDate()+daysAhead);
  return d.toISOString().split('T')[0];
}
function timeAgo(d) {
  const s=(Date.now()-new Date(d))/1000;
  if(s<60) return 'ahora'; if(s<3600) return `hace ${Math.floor(s/60)}m`;
  if(s<86400) return `hace ${Math.floor(s/3600)}h`; return `hace ${Math.floor(s/86400)}d`;
}
function fmt(sec) { return `${String(Math.floor(sec/60)).padStart(2,'0')}:${String(sec%60).padStart(2,'0')}`; }

const CLS = {
  interested:{ label:'Interesado',    color:'#10b981', bg:'#d1fae5' },
  needs_info:{ label:'Necesita info', color:'#f59e0b', bg:'#fef3c7' },
  no_info:   { label:'Sin info',      color:'#ef4444', bg:'#fee2e2' },
};
const EVENT_TYPES = {
  cita:    { label:'Cita',       color:'#4f6ef7', Icon:Calendar },
  llamada: { label:'Llamada',    color:'#10b981', Icon:Phone    },
  video:   { label:'Videollamada',color:'#8b5cf6', Icon:Video   },
};
const MONTHS = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
const MONTH_DATA = [3,5,4,7,6,8,5,9,11,8,12,10];

/* ─────────────────────────── UI COMPONENTS ─────────────────────────── */
function Card({ title, Icon, iconColor=DS.primary, children, action, noPad }) {
  return (
    <div style={{ background:'var(--card-bg,#fff)',borderRadius:16,border:'1px solid #e5e7eb', boxSizing:'border-box', overflow:'hidden' }}>
      {title && (
        <div style={{ padding:'16px 20px', borderBottom:'1px solid #e2e8f0', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <h3 style={{ margin:0, fontSize:16, fontWeight:700, color:NAVY, display:'flex', alignItems:'center', gap:8 }}>
            <Icon size={14} color={iconColor}/> {title}
          </h3>
          {action}
        </div>
      )}
      <div style={{ padding: noPad ? 0 : 20 }}>{children}</div>
    </div>
  );
}

function Badge({ label, color, bg }) {
  return <span style={{ padding:'2px 9px', borderRadius:999, fontSize:11, fontWeight:700, color, background:bg }}>{label}</span>;
}

function ScoreBadge({ score }) {
  const c=score>=80?'#10b981':score>=50?'#f59e0b':'#ef4444';
  const b=score>=80?'#d1fae5':score>=50?'#fef3c7':'#fee2e2';
  return <Badge label={score} color={c} bg={b}/>;
}

function Btn({ children, onClick, color=DS.primary, bg='#eef2ff', icon: Icon, sm }) {
  return (
    <button onClick={onClick} style={{ padding:sm?'5px 9px':'9px 14px', borderRadius:8, border:'none', background:bg, color, fontWeight:700, fontSize:sm?11:13, cursor:'pointer', display:'flex', alignItems:'center', gap:5, whiteSpace:'nowrap' }}>
      {Icon && <Icon size={sm?11:13}/>}{children}
    </button>
  );
}

function BarMini({ data, labels, color=DS.primary }) {
  const max=Math.max(...data)||1;
  return (
    <div style={{ display:'flex', gap:3, alignItems:'flex-end', height:64 }}>
      {data.map((v,i) => (
        <div key={i} style={{ flex:1, display:'flex', flexDirection:'column', alignItems:'center', gap:2 }}>
          <div style={{ width:'100%', background:`${color}18`, borderRadius:4, height:52, display:'flex', alignItems:'flex-end' }}>
            <div style={{ width:'100%', background:color, borderRadius:4, height:`${(v/max)*100}%`, transition:'height 0.4s' }}/>
          </div>
          {labels && <div style={{ fontSize:7, color:'#9aa5be', fontWeight:600 }}>{labels[i]}</div>}
        </div>
      ))}
    </div>
  );
}

/* ════════════════════════════════════════════════════════════════════
   TAB 1 — DASHBOARD
═══════════════════════════════════════════════════════════════════ */

// ── Canal Stats — Estadísticas por red social ─────────────────────────────




function TabClientes({ clients, setClients, asesores, leads, onVerConversacion, initialClient, onInitialDone }) {
  const [search, setSearch]   = useState('');
  const [filterA, setFilterA] = useState('all');
  const [filterR, setFilterR] = useState('all');
  const [detail, setDetail]   = useState(null);
  useEffect(()=>{ if(initialClient){ setDetail(initialClient); onInitialDone && onInitialDone(); } },[initialClient]);

  const filtered = clients.filter(c=>{
    const ms = c.name.toLowerCase().includes(search.toLowerCase())||c.phone.includes(search);
    const ma = filterA==='all' || c.asesorId===filterA;
    const mr = filterR==='all'||(filterR==='proceso'&&!c.result)||(filterR==='won'&&c.result==='won')||(filterR==='lost'&&c.result==='lost');
    return ms&&ma&&mr;
  });

  const { paged, ...pg } = usePaged(filtered, 12);

  return (
    <div style={{ display:'grid', gridTemplateColumns:MOB?'1fr':'1fr 290px', gap:20 }}>
      <div>
        {/* Filtros */}
        <div style={{ display:'flex', gap:10, marginBottom:14, flexWrap:'wrap' }}>
          <div style={{ flex:1, minWidth:200, position:'relative' }}>
            <Search size={13} color="#94a3b8" style={{ position:'absolute', left:11, top:'50%', transform:'translateY(-50%)' }}/>
            <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Buscar cliente o teléfono..."
              style={{ width:'100%', padding:'9px 12px 9px 32px', border:'1px solid #cbd5e1', borderRadius:10, fontSize:13, outline:'none', boxSizing:'border-box' }}/>
          </div>
          <select value={filterA} onChange={e=>setFilterA(e.target.value)} style={{ padding:'9px 12px', border:'1px solid #cbd5e1', borderRadius:10, fontSize:13, outline:'none', cursor:'pointer' }}>
            <option value="all">Todos los asesores</option>
            {(asesores||[]).map(a=><option key={a.id} value={a.id}>{a.name}</option>)}
          </select>
          <select value={filterR} onChange={e=>setFilterR(e.target.value)} style={{ padding:'9px 12px', border:'1px solid #cbd5e1', borderRadius:10, fontSize:13, outline:'none', cursor:'pointer' }}>
            <option value="all">Todos los estados</option>
            <option value="proceso">En proceso</option>
            <option value="won">Ganados</option>
            <option value="lost">Perdidos</option>
          </select>
        </div>

        {/* Tabla */}
        <div style={{ background:'var(--card-bg,#fff)',borderRadius:16,border:'1px solid #e5e7eb', overflowX:'auto' }}>
          <table style={{ width:'100%', borderCollapse:'collapse', minWidth:680 }}>
            <thead>
              <tr style={{borderBottom:'1px solid #eef0f3'}}>
                {['Cliente','Teléfono','Asesor','Clasificación','Estado','Producto/Servicio','Acc.'].map(h=>(
                  <th key={h} style={{ padding:'9px 14px', textAlign:'left', fontSize:12,fontWeight:600,color:'#94a3b8' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {paged.map(c=>{
                const cls=CLS[c.classification]||{};
                return (
                  <tr key={c.id} style={{ borderTop:'1px solid #e2e8f0', cursor:'pointer' }} onClick={()=>setDetail(c)}>
                    <td style={{ padding:'11px 14px' }}>
                      <div style={{ fontSize:13, fontWeight:700, color:'var(--dark,#0f172a)' }}>{c.name}</div>
                      <div style={{ fontSize:10, color:'#9aa5be' }}>{timeAgo(c.lastContact)}</div>
                    </td>
                    <td style={{ padding:'11px 14px', fontSize:12, color:'#4a5568' }}>{c.phone}</td>
                    <td style={{ padding:'11px 14px', fontSize:12, fontWeight:600, color:DS.primary }}>{c.asesor ? c.asesor.split(' ')[0] : 'Sin asignar'}</td>
                    <td style={{ padding:'11px 14px' }}><Badge label={cls.label} color={cls.color} bg={cls.bg}/></td>
                    <td style={{ padding:'11px 14px' }}>
                      {c.result==='won'  && <span style={{ color:'#10b981', fontWeight:700, fontSize:12 }}> Ganado</span>}
                      {c.result==='lost' && <span style={{ color:'#ef4444', fontWeight:700, fontSize:12 }}> Perdido</span>}
                      {!c.result         && <span style={{ color:'#f59e0b', fontWeight:700, fontSize:12 }}>● Proceso</span>}
                    </td>
                    <td style={{ padding:'11px 14px', maxWidth:160 }}>
                      {(() => { const p = c.producto || c.metadata?.producto; return p
                        ? <span style={{ fontSize:11, fontWeight:700, color:'#1e40af', background:'#dbeafe', padding:'3px 9px', borderRadius:6, display:'inline-block', whiteSpace:'nowrap' }}>{p}</span>
                        : <span style={{ fontSize:11, color:'#9aa5be' }}>—</span>; })()}
                    </td>
                    <td style={{ padding:'11px 14px' }} onClick={e=>e.stopPropagation()}>
                      <Btn onClick={()=>setDetail(c)} color={DS.primary} bg="#eef2ff" icon={Eye} sm>Ver</Btn>
                    </td>
                  </tr>
                );
              })}
              {filtered.length===0 && <tr><td colSpan={7} style={{ padding:32, textAlign:'center', color:'#9aa5be', fontSize:13 }}>Sin resultados</td></tr>}
            </tbody>
          </table>
        </div>
        <Pagination {...pg} primary={DS.primary} label="clientes" />
      </div>

      {/* Sidebar */}
      <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
        <Card title="Resumen del equipo" Icon={BarChart2}>
          {(asesores||[]).map(a=>{
            const ac=clients.filter(c=>c.asesorId===a.id);
            const won=ac.filter(c=>c.result==='won').length;
            const lost=ac.filter(c=>c.result==='lost').length;
            return (
              <div key={a.id} style={{ padding:'10px 0', borderBottom:'1px solid #e2e8f0' }}>
                <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4 }}>
                  <div style={{ fontSize:12, fontWeight:700, color:'var(--dark,#0f172a)' }}>{a.name.split(' ')[0]}</div>
                  <ScoreBadge score={a.score}/>
                </div>
                <div style={{ fontSize:11, color:'#9aa5be' }}>{ac.length} clientes · <span style={{ color:'#10b981', fontWeight:700 }}>{won} ganados</span> · <span style={{ color:'#ef4444', fontWeight:700 }}>{lost} perdidos</span></div>
              </div>
            );
          })}
        </Card>

        <Card title="Clientes perdidos" Icon={XCircle} iconColor="#ef4444">
          {clients.filter(c=>c.result==='lost').map(c=>(
            <div key={c.id} style={{ padding:'9px 0', borderBottom:'1px solid #e2e8f0', cursor:'pointer' }} onClick={()=>setDetail(c)}>
              <div style={{ fontSize:12, fontWeight:700, color:'var(--dark,#0f172a)' }}>{c.name}</div>
              <div style={{ fontSize:11, color:'#ef4444', fontWeight:600 }}>{c.asesor ? c.asesor.split(' ')[0] : 'Sin asignar'}</div>
              {c.lossReason && <div style={{ fontSize:10, color:'#9aa5be', fontStyle:'italic', marginTop:2 }}>"{c.lossReason.substring(0,40)}..."</div>}
            </div>
          ))}
        </Card>
      </div>

      {/* Modal detalle */}
      {detail && <ClientDetailModal client={detail} onClose={()=>setDetail(null)} setClients={setClients} asesores={asesores} leads={leads} onVerConversacion={onVerConversacion}/>}
    </div>
  );

}

function ClientDetailModal({ client, onClose, setClients, asesores, leads, onVerConversacion }) {
  const cls = CLS[client.classification]||{};
  const [editing, setEditing] = React.useState(false);
  const [saving,  setSaving]  = React.useState(false);
  const [nuevoAsesor, setNuevoAsesor] = React.useState('');
  const [reasignando, setReasignando] = React.useState(false);

  async function reasignarAsesor() {
    if (!nuevoAsesor) return;
    const a = withSup(asesores).find(x => String(x.id) === String(nuevoAsesor));
    setReasignando(true);
    try {
      await apiFetch('PUT', `/api/clients/${client.id}`, { assignedAdvisorId: nuevoAsesor });
      if (setClients) setClients(prev => prev.map(c => c.id === client.id ? { ...c, asesor: a?.name || c.asesor, asesorId: nuevoAsesor, assigned_advisor_id: nuevoAsesor, advisor_name: a?.name || c.advisor_name } : c));
      alert(`✅ Cliente reasignado${a?.name?' a '+a.name:''}.`);
      onClose();
    } catch(e) { alert('Error al reasignar: ' + e.message); }
    setReasignando(false);
  }

  // Buscar el lead (conversación del bot) que corresponde a este cliente por teléfono
  const leadDeCliente = React.useMemo(() => {
    if (!Array.isArray(leads)) return null;
    const cw = toWA(client.phone);
    return leads.find(l => toWA(l.telefono) === cw) || null;
  }, [leads, client.phone]);

  function verConversacion() {
    if (!leadDeCliente) { alert('Este cliente aún no tiene una conversación registrada con el bot.'); return; }
    onClose();
    if (onVerConversacion) onVerConversacion(leadDeCliente);
  }
  const [form, setForm] = React.useState({
    name:       client.name        || '',
    phone:      client.phone       || '',
    email:      client.email       || '',
    notes:      client.notes       || '',
    lossReason: client.lossReason  || '',
    producto:   client.producto || client.metadata?.producto || '',
  });

  async function guardar() {
    setSaving(true);
    try {
      await apiFetch('PUT', `/api/asesor/clients/${client.id}`, {
        name: form.name, phone: form.phone, email: form.email,
        notes: form.notes, lossReason: form.lossReason, producto: form.producto,
      });
      if (setClients) setClients(prev => prev.map(c => c.id === client.id ? { ...c, ...form } : c));
      setEditing(false);
    } catch(e) { alert('Error al guardar: ' + e.message); }
    setSaving(false);
  }

  function eliminar() {
    askConfirm(`¿Eliminar a ${client.name}? Esta acción no se puede deshacer.`, async () => {
      try {
        await apiFetch('DELETE', `/api/clients/${client.id}`);
        if (setClients) setClients(prev => prev.filter(c => c.id !== client.id));
        onClose();
      } catch(e) { alert('Error al eliminar: ' + e.message); }
    });
  }

  const inp = { width:'100%', padding:'9px 12px', border:'1px solid #e5e7eb',borderRadius:10,background:'#fff', fontSize:13, outline:'none', boxSizing:'border-box', fontFamily:'inherit' };

  return (
    <div style={{ position:'fixed', inset:0, backdropFilter:'blur(12px)', WebkitBackdropFilter:'blur(8px)', background:'rgba(var(--primary-rgb),0.35)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:9999 }}>
      <div style={{ background:'#ffffff', borderRadius:24, padding:32, width:520, maxHeight:'88vh', overflowY:'auto', boxShadow:'0 24px 64px rgba(0,0,0,0.3)' }}>

        {/* Header */}
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:20 }}>
          <div>
            <h2 style={{ margin:'0 0 6px', fontSize:20, fontWeight:800, color:'var(--dark,#0f172a)' }}>{client.name}</h2>
            <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
              <Badge label={cls.label} color={cls.color} bg={cls.bg}/>
              <ScoreBadge score={client.score}/>
              {client.result==='won'  && <Badge label="Ganado"  color="#10b981" bg="#d1fae5"/>}
              {client.result==='lost' && <Badge label="Perdido" color="#ef4444" bg="#fee2e2"/>}
            </div>
          </div>
          <div style={{ display:'flex', gap:8 }}>
            <button onClick={()=>setEditing(!editing)} style={{ border:'none', background: editing ? DS.primary : '#f1f5f9', borderRadius:8, padding:'7px 12px', cursor:'pointer', display:'flex', alignItems:'center', gap:5, color: editing ? '#fff' : '#475569', fontSize:12, fontWeight:700 }}>
              <Edit2 size={13}/> {editing ? 'Cancelar' : 'Editar'}
            </button>
            <button onClick={onClose} style={{ border:'none', background:'rgba(var(--primary-rgb),0.10)', borderRadius:8, padding:'8px 10px', cursor:'pointer' }}><X size={16} color="#64748b"/></button>
          </div>
        </div>

        {/* Ver conversación del bot ↔ cliente */}
        <button onClick={verConversacion}
          style={{ width:'100%', marginBottom:16, padding:'12px', borderRadius:12, border:'none', cursor:'pointer',
            background: leadDeCliente ? '#f0fdf9' : '#f8fafc', color: leadDeCliente ? '#059669' : '#94a3b8',
            fontWeight:800, fontSize:13, display:'flex', alignItems:'center', justifyContent:'center', gap:8 }}>
          <MessageCircle size={16}/> Ver conversación del cliente
        </button>

        {/* Campos editables o de solo lectura */}
        {editing ? (
          <div style={{ display:'flex', flexDirection:'column', gap:10, marginBottom:16 }}>
            {[
              { label:'Nombre', key:'name', type:'text' },
              { label:'Teléfono', key:'phone', type:'tel' },
              { label:'Email', key:'email', type:'email' },
            ].map(f=>(
              <div key={f.key}>
                <div style={{ fontSize:10, color:'#9aa5be', fontWeight:700, marginBottom:4 }}>{f.label.toUpperCase()}</div>
                <input type={f.type} value={form[f.key]} onChange={e=>setForm(p=>({...p,[f.key]:e.target.value}))} style={inp}/>
              </div>
            ))}
            <div>
              <div style={{ fontSize:10, color:'#9aa5be', fontWeight:700, marginBottom:4 }}>NOTAS</div>
              <textarea value={form.notes} onChange={e=>setForm(p=>({...p,notes:e.target.value}))} rows={3} style={{...inp, resize:'none'}}/>
            </div>
            <div>
              <div style={{ fontSize:10, color:'#1d4ed8', fontWeight:700, marginBottom:4 }}>PRODUCTO / SERVICIO</div>
              <select value={form.producto} onChange={e=>setForm(p=>({...p,producto:e.target.value}))} style={inp}>
                <option value="">— Sin asignar —</option>
                <option value="Estrella">⭐ Estrella</option>
                <option value="Súper Estrella">⭐⭐ Súper Estrella</option>
                <option value="Mega Estrella">⭐⭐⭐ Mega Estrella</option>
                <option value="Contado">💵 Contado</option>
              </select>
            </div>
            {client.result==='lost' && (
              <div>
                <div style={{ fontSize:10, color:'#dc2626', fontWeight:700, marginBottom:4 }}>CONCEPTO (RAZÓN DE PÉRDIDA)</div>
                <textarea value={form.lossReason} onChange={e=>setForm(p=>({...p,lossReason:e.target.value}))} rows={2} placeholder="Describe por qué se perdió este cliente..." style={{...inp, resize:'none'}}/>
              </div>
            )}
            <button onClick={guardar} disabled={saving} style={{ padding:'11px', borderRadius:10, border:'none', background:DS.primary, color:'#fff', fontWeight:700, fontSize:13, cursor:'pointer' }}>
              {saving ? 'Guardando...' : '✓ Guardar cambios'}
            </button>
          </div>
        ) : (
          <>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:16 }}>
              {[
                { label:'ASESOR',          value: client.asesor || '—' },
                { label:'TELÉFONO',        value: client.phone },
                { label:'CÉDULA / RUC',    value: client.cedula || client.metadata?.cedula || '—' },
                { label:'EMAIL',           value: client.email || '—' },
                { label:'ÚLTIMO CONTACTO', value: timeAgo(client.lastContact) },
              ].map((f,i)=>(
                <div key={i} style={{ background:'#f5f7fb', borderRadius:10, padding:'12px 14px' }}>
                  <div style={{ fontSize:10, color:'#9aa5be', fontWeight:700, marginBottom:4 }}>{f.label}</div>
                  <div style={{ fontSize:13, fontWeight:600, color:'#4a5568' }}>{f.value}</div>
                </div>
              ))}
            </div>
            {/* Reasignar asesor */}
            <div style={{ background:'#f0f1ff', borderRadius:12, padding:'14px 16px', border:`1px solid ${DS.primary}25`, marginBottom:12 }}>
              <div style={{ fontSize:11, fontWeight:700, color:DS.primary, marginBottom:8, textTransform:'uppercase', letterSpacing:0.5, display:'flex', alignItems:'center', gap:6 }}>
                <UserCheck size={13}/> Cambiar de asesor
              </div>
              <div style={{ display:'flex', gap:8 }}>
                <select value={nuevoAsesor} onChange={e=>setNuevoAsesor(e.target.value)}
                  style={{ flex:1, padding:'9px 12px', border:'1px solid #e5e7eb',borderRadius:10,background:'#fff', fontSize:13, outline:'none', background:'#fff', cursor:'pointer' }}>
                  <option value="">— Selecciona un asesor —</option>
                  {withSup(asesores).map(a=><option key={a.id} value={a.id}>{a.name}</option>)}
                </select>
                <button onClick={reasignarAsesor} disabled={!nuevoAsesor||reasignando}
                  style={{ padding:'9px 16px', borderRadius:9, border:'none', background:!nuevoAsesor||reasignando?'#a5b4fc':DS.primary, color:'#fff', fontWeight:700, fontSize:13, cursor:!nuevoAsesor||reasignando?'default':'pointer', whiteSpace:'nowrap' }}>
                  {reasignando?'Reasignando...':'Reasignar'}
                </button>
              </div>
            </div>
            {client.notes && (
              <div style={{ background:'#fef3c7', borderRadius:10, padding:'12px 14px', marginBottom:12, fontSize:13, color:'#92400e' }}>
                <b>Notas:</b> {client.notes}
              </div>
            )}
            {(client.producto || client.metadata?.producto) && (
              <div style={{ background:'#eff6ff', borderRadius:10, padding:'14px 16px', border:'1px solid #bfdbfe', marginBottom:12 }}>
                <div style={{ fontSize:11, fontWeight:700, color:'#1d4ed8', marginBottom:6, textTransform:'uppercase', letterSpacing:0.5 }}>Producto / Servicio</div>
                <div style={{ fontSize:14, fontWeight:700, color:'#1e40af' }}>{client.producto || client.metadata?.producto}</div>
              </div>
            )}
            {client.result==='lost' && (
              <div style={{ background:'#fef2f2', borderRadius:10, padding:'14px 16px', border:'1px solid #fecaca', marginBottom:12 }}>
                <div style={{ fontSize:11, fontWeight:700, color:'#dc2626', marginBottom:6, textTransform:'uppercase', letterSpacing:0.5 }}>Concepto (Razón de pérdida)</div>
                <div style={{ fontSize:13, color:'#7f1d1d', lineHeight:1.5 }}>
                  {client.lossReason || <span style={{ color:'#9aa5be', fontStyle:'italic' }}>No registrado</span>}
                </div>
              </div>
            )}
          </>
        )}

        {/* Acciones */}
        <div style={{ display:'flex', gap:10, marginTop:16 }}>
          <a href={`https://wa.me/${toWA(client.phone)}`} target="_blank" rel="noreferrer" onClick={()=>marcarContactado(client.phone)}
            style={{ flex:1, padding:'10px 0', borderRadius:10, background:'#f0fdf4', color:'#16a34a', fontWeight:700, fontSize:13, display:'flex', alignItems:'center', justifyContent:'center', gap:6, textDecoration:'none' }}>
            <MessageCircle size={14}/> WhatsApp
          </a>
          <a href={`tel:${client.phone}`}
            style={{ flex:1, padding:'10px 0', borderRadius:10, background:'rgba(var(--primary-rgb),0.10)', color:DS.primary, fontWeight:700, fontSize:13, display:'flex', alignItems:'center', justifyContent:'center', gap:6, textDecoration:'none' }}>
            <Phone size={14}/> Llamar
          </a>
          <button onClick={eliminar}
            style={{ padding:'10px 14px', borderRadius:10, border:'none', background:'#fef2f2', color:'#ef4444', fontWeight:700, fontSize:13, cursor:'pointer', display:'flex', alignItems:'center', gap:5 }}>
            <Trash2 size={14}/> Eliminar
          </button>
        </div>
      </div>
    </div>
  );
}

/* ════════════════════════════════════════════════════════════════════
   TAB 3 — ASESORES
═══════════════════════════════════════════════════════════════════ */
function TabAsesores({ clients, asesores: asesoresReal, teamActivities=[], onNavigate, onSelectContact }) {
  const asesores = asesoresReal || [];
  const [expanded, setExpanded] = React.useState(null);
  const [msgModal, setMsgModal] = React.useState(null); // kept for compatibility

  function exportPerformance() {
    const rows = [['Asesor','Email','Estado','Clientes','Ganados','Perdidos','En proceso','Conversión %']];
    asesores.forEach(a=>{
      const ac = clients.filter(c=>c.asesorId===a.id||c.assigned_advisor_id===a.id);
      const won = ac.filter(c=>c.result==='won').length;
      const lost= ac.filter(c=>c.result==='lost').length;
      rows.push([a.name,a.email||'',a.active?'Online':'Offline',ac.length,won,lost,ac.length-won-lost,ac.length?Math.round((won/ac.length)*100):0]);
    });
    const csv = rows.map(r=>r.join(',')).join('\n');
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([csv],{type:'text/csv'}));
    a.download = 'performance_asesores.csv'; a.click();
  }

  return (
    <div style={{ display:'grid', gridTemplateColumns:MOB?'1fr':'1fr 290px', gap:20 }}>
      <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
        {asesores.map(a=>{
          const ac = clients.filter(c=>c.asesorId===a.id||c.assigned_advisor_id===a.id);
          const won  = ac.filter(c=>c.result==='won').length;
          const lost = ac.filter(c=>c.result==='lost').length;
          const inProc=ac.filter(c=>!c.result).length;
          const conv = ac.length?Math.round((won/ac.length)*100):0;
          const open = expanded===a.id;
          return (
            <div key={a.id} style={{ background:'var(--card-bg,#fff)',borderRadius:16,border:'1px solid #e5e7eb', overflow:'hidden' }}>
              {/* Header */}
              <div style={{ padding:'16px 20px', display:'flex', gap:14, alignItems:'center', cursor:'pointer' }} onClick={()=>setExpanded(open?null:a.id)}>
                <div style={{ width:46, height:46, borderRadius:'50%', background:'rgba(var(--primary-rgb),0.10)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:18, fontWeight:800, color:DS.primary, flexShrink:0 }}>{a.name.charAt(0)}</div>
                <div style={{ flex:1 }}>
                  <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:3 }}>
                    <span style={{ fontSize:15, fontWeight:800, color:'var(--dark,#0f172a)' }}>{a.name}</span>
                    <div style={{ width:8, height:8, borderRadius:'50%', background:a.active?'#10b981':'#94a3b8' }}/>
                    <span style={{ fontSize:11, color:a.active?'#10b981':'#94a3b8', fontWeight:600 }}>{a.active?'Online':'Offline'}</span>
                  </div>
                  <div style={{ fontSize:12, color:'#9aa5be' }}>{a.email} · {ac.length} clientes</div>
                </div>
                <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                  <ScoreBadge score={a.score}/>
                  <button onClick={e=>{e.stopPropagation(); if(onSelectContact) onSelectContact(a.id); if(onNavigate) onNavigate('messages');}} style={{ padding:'6px 10px', borderRadius:8, border:'none', background:'rgba(var(--primary-rgb),0.10)', cursor:'pointer', display:'flex', alignItems:'center', gap:5, color:DS.primary, fontSize:12, fontWeight:700 }}><Send size={13}/> Mensaje</button>
                  {open ? <span style={{fontSize:16,color:'#9aa5be',fontWeight:700}}>▲</span> : <span style={{fontSize:16,color:'#9aa5be',fontWeight:700}}>▼</span>}
                </div>
              </div>

              {open && (
                <div style={{ padding:'0 20px 20px', borderTop:'1px solid #e2e8f0' }}>
                  {/* Stats */}
                  <div style={{ display:'grid', gridTemplateColumns:MOB?'repeat(2,1fr)':'repeat(4,1fr)', gap:10, margin:'14px 0' }}>
                    {[
                      { label:'Clientes',  value:ac.length,  color:DS.primary },
                      { label:'Ganados',   value:won,         color:'#10b981' },
                      { label:'Perdidos',  value:lost,        color:'#ef4444' },
                      { label:'Conversión',value:`${conv}%`,  color:'#8b5cf6' },
                    ].map((s,i)=>(
                      <div key={i} style={{ background:'#f5f7fb', borderRadius:10, padding:'12px', textAlign:'center' }}>
                        <div style={{ fontSize:20, fontWeight:800, color:s.color }}>{s.value}</div>
                        <div style={{ fontSize:10, color:'#9aa5be' }}>{s.label}</div>
                      </div>
                    ))}
                  </div>

                  {/* Métricas adicionales */}
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:14 }}>
                    <div style={{ background:'#f5f7fb', borderRadius:10, padding:'12px 14px' }}>
                      <div style={{ fontSize:11, color:'#9aa5be', fontWeight:700, marginBottom:4 }}>LLAMADAS TOTALES</div>
                      <div style={{ fontSize:18, fontWeight:800, color:'#4a5568' }}>{a.calls}</div>
                      <div style={{ fontSize:11, color:'#9aa5be' }}>Prom. {fmt(a.avgDur)} por llamada</div>
                    </div>
                    <div style={{ background:'#f5f7fb', borderRadius:10, padding:'12px 14px' }}>
                      <div style={{ fontSize:11, color:'#9aa5be', fontWeight:700, marginBottom:4 }}>RACHA</div>
                      <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                        <span style={{ fontSize:18, fontWeight:800, color:a.streak>0?'#d97706':'#94a3b8' }}>{a.streak}</span>
                        <span style={{ fontSize:12, color:'#9aa5be' }}>días activo</span>
                        {a.streak>=3 && <span style={{ fontSize:14 }}></span>}
                      </div>
                    </div>
                  </div>

                  {/* Clientes en proceso */}
                  {inProc > 0 && (
                    <div>
                      <div style={{ fontSize:12, fontWeight:700, color:'#9aa5be', textTransform:'uppercase', letterSpacing:0.5, marginBottom:8 }}>Clientes activos</div>
                      {ac.filter(c=>!c.result).map(c=>{
                        const cls=CLS[c.classification]||{};
                        const lastAct=teamActivities.filter(x=>x.client_id===c.id||x.client_name===c.name).sort((x,y)=>new Date(y.created_at)-new Date(x.created_at))[0];
                        return (
                          <div key={c.id} style={{ padding:'9px 0', borderBottom:'1px solid #e2e8f0' }}>
                            <div style={{ display:'flex', gap:10, alignItems:'center', marginBottom: (c.notes||lastAct?.notas)?4:0 }}>
                              <div style={{ flex:1 }}>
                                <div style={{ fontSize:12, fontWeight:700, color:'var(--dark,#0f172a)' }}>{c.name}</div>
                                <div style={{ fontSize:10, color:'#9aa5be' }}>{timeAgo(c.lastContact)}</div>
                              </div>
                              <Badge label={cls.label} color={cls.color} bg={cls.bg}/>
                              <ScoreBadge score={c.score}/>
                            </div>
                            {c.notes && (
                              <div style={{ fontSize:11, color:'#92400e', background:'#fef3c7', borderRadius:7, padding:'5px 9px', marginTop:3 }}>
                                <b>Nota:</b> {c.notes}
                              </div>
                            )}
                            {lastAct?.notas && (
                              <div style={{ fontSize:11, color:'#1e40af', background:'#eff6ff', borderRadius:7, padding:'5px 9px', marginTop:3 }}>
                                <b>{lastAct.type||'Actividad'}:</b> {lastAct.notas}
                                {lastAct.resultado && <span style={{color:DS.primary,marginLeft:6}}>→ {lastAct.resultado}</span>}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {/* Pérdidas con razón */}
                  {ac.filter(c=>c.result==='lost'&&c.lossReason).length>0 && (
                    <div style={{ marginTop:12 }}>
                      <div style={{ fontSize:12, fontWeight:700, color:'#9aa5be', textTransform:'uppercase', letterSpacing:0.5, marginBottom:8 }}>Razones de pérdida</div>
                      {ac.filter(c=>c.result==='lost'&&c.lossReason).map(c=>(
                        <div key={c.id} style={{ background:'#fef2f2', borderRadius:8, padding:'9px 12px', marginBottom:6, border:'1px solid #fecaca' }}>
                          <div style={{ fontSize:12, fontWeight:700, color:'var(--dark,#0f172a)', marginBottom:3 }}>{c.name}</div>
                          <div style={{ fontSize:11, color:'#7f1d1d' }}>{c.lossReason}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Sidebar */}
      <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
        <Card title="Performance general" Icon={BarChart2}>
          <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
            {[...asesores].sort((a,b)=>(b.score||0)-(a.score||0)).map((a,i)=>(
              <div key={a.id}>
                <div style={{ display:'flex', justifyContent:'space-between', marginBottom:3 }}>
                  <span style={{ fontSize:12, fontWeight:700, color:'#4a5568' }}>{a.name.split(' ')[0]}</span>
                  <span style={{ fontSize:12, fontWeight:800, color:DS.primary }}>{a.score}</span>
                </div>
                <div style={{ background:'rgba(var(--primary-rgb),0.10)', borderRadius:999, height:7 }}>
                  <div style={{ width:`${a.score}%`, height:'100%', background:a.score>=80?'#10b981':a.score>=50?'#f59e0b':'#ef4444', borderRadius:999 }}/>
                </div>
              </div>
            ))}
          </div>
        </Card>

        <Card title="Acciones rápidas" Icon={Zap} iconColor="#10b981">
          <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
            <Btn color="#ef4444" bg="#fef2f2" icon={AlertCircle}>Reportar bajo rendimiento</Btn>
            <Btn color={DS.primary} bg="#eef2ff" icon={Download} onClick={exportPerformance}>Exportar performance</Btn>
            <Btn color="#16a34a" bg="#f0fdf4" icon={MessageCircle}>Mensaje grupal</Btn>
          </div>
        </Card>
      </div>
    </div>
  );
}


/* ════════════════════════════════════════════════════════════════════
   TAB 4 — CALENDARIO
═══════════════════════════════════════════════════════════════════ */
function TabCalendario({ events, setEvents, asesores }) {
  const today = new Date();
  const [cur,    setCur]    = useState(new Date(today.getFullYear(), today.getMonth(), 1));
  const [sel,    setSel]    = useState(null);
  const [modal,  setModal]  = useState(false);
  const [editEv, setEditEv] = useState(null);
  const [form,   setForm]   = useState({ type:'cita', title:'', clientName:'', asesorId:'a1', date:'', time:'', description:'' });

  const y=cur.getFullYear(), m=cur.getMonth();
  const firstDay=new Date(y,m,1).getDay(), dim=new Date(y,m+1,0).getDate();
  const monthName=cur.toLocaleDateString('es-MX',{month:'long',year:'numeric'});

  const byDay={};
  events.forEach(e=>{
    const d=new Date(e.date);
    if(d.getFullYear()===y&&d.getMonth()===m){
      const k=d.getDate();
      if(!byDay[k])byDay[k]=[];
      byDay[k].push(e);
    }
  });

  const cells=[];
  for(let i=0;i<firstDay;i++)cells.push(null);
  for(let d=1;d<=dim;d++)cells.push(d);

  function openNew() {
    const dateVal = sel ? `${y}-${String(m+1).padStart(2,'0')}-${String(sel).padStart(2,'0')}` : dateStr(0);
    setForm({ type:'cita', title:'', clientName:'', asesorId:'a1', date:dateVal, time:'', description:'' });
    setEditEv(null);
    setModal(true);
  }

  function openEdit(e, ev) {
    ev.stopPropagation();
    setForm({ type:e.type, title:e.title, clientName:e.clientName, asesorId:e.asesorId, date:e.date, time:e.time, description:e.description||'' });
    setEditEv(e.id);
    setModal(true);
  }

  async function saveEvent() {
    if(!form.title||!form.date||!form.time||!form.clientName){ alert('Completa título, cliente, fecha y hora'); return; }
    // El título va como primera línea de notes y la descripción debajo (la tabla no tiene columna title)
    const notes = `${form.title}${form.description ? '\n'+form.description : ''}`;
    const payload = { clientName:form.clientName, type:form.type, eventDate:form.date, eventTime:form.time, notes };
    try {
      if(editEv) {
        await apiFetch('PUT', `/api/supervisor/calendar/${editEv}`, payload);
        setEvents(prev=>prev.map(e=>e.id===editEv?{...e,...form,clientId:null}:e));
      } else {
        const r = await apiFetch('POST', '/api/supervisor/calendar', payload);
        setEvents(prev=>[...prev,{ id:r?.id||('e'+Date.now()), ...form, clientId:null, done:false }]);
      }
      setModal(false);
    } catch(e) { alert('Error al guardar evento: '+e.message); }
  }

  function toggleDone(id, ev) {
    ev.stopPropagation();
    const cur = events.find(e=>e.id===id);
    const newDone = !cur?.done;
    setEvents(prev=>prev.map(e=>e.id===id?{...e,done:newDone}:e));
    apiFetch('PUT', `/api/supervisor/calendar/${id}`, { done:newDone }).catch(()=>{});
  }

  function deleteEvent(id, ev) {
    ev.stopPropagation();
    askConfirm('Este evento será eliminado permanentemente.', async ()=>{
      setEvents(prev=>prev.filter(e=>e.id!==id));
      try { await apiFetch('DELETE', `/api/supervisor/calendar/${id}`); } catch(e) {}
    });
  }

  const upcoming = events.filter(e=>!e.done&&new Date(e.date)>=today).sort((a,b)=>new Date(a.date)-new Date(b.date));

  return (
    <div style={{ display:'grid', gridTemplateColumns:MOB?'1fr':'1fr 290px', gap:20 }}>
      {/* Columna izquierda */}
      <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
        {/* Métricas */}
        <div style={{ display:'grid', gridTemplateColumns:MOB?'repeat(2,1fr)':'repeat(3,1fr)', gap:12 }}>
          {[
            { label:'Eventos este mes', value:events.filter(e=>{const d=new Date(e.date);return d.getMonth()===m&&d.getFullYear()===y;}).length, Icon:Calendar, color:DS.primary },
            { label:'Pendientes',       value:events.filter(e=>!e.done&&new Date(e.date)>=today).length, Icon:Clock,    color:'#f59e0b' },
            { label:'Completados',      value:events.filter(e=>e.done).length, Icon:CheckCircle, color:'#10b981' },
          ].map((s,i)=>(
            <div key={i} style={{ background:'var(--card-bg,#fff)', borderRadius:16, padding:'14px 16px', border:'1px solid #e5e7eb', display:'flex', alignItems:'center', gap:10 }}>
              <div style={{ width:36, height:36, borderRadius:10, background:`${s.color}15`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}><s.Icon size={17} color={s.color}/></div>
              <div><div style={{ fontSize:20, fontWeight:800, color:'var(--dark,#0f172a)' }}>{s.value}</div><div style={{ fontSize:10, color:'#9aa5be', fontWeight:600 }}>{s.label}</div></div>
            </div>
          ))}
        </div>

        {/* Calendario */}
        <div style={{ background:'var(--card-bg,#fff)', borderRadius:16, padding:22, border:'1px solid #e5e7eb' }}>
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:16 }}>
            <button onClick={()=>setCur(new Date(y,m-1,1))} style={{ border:'none', background:'rgba(var(--primary-rgb),0.10)', borderRadius:8, padding:'6px 10px', cursor:'pointer', display:'flex' }}><ChevronLeft size={16} color="#64748b"/></button>
            <span style={{ fontSize:14, fontWeight:700, color:'var(--dark,#0f172a)', textTransform:'capitalize' }}>{monthName}</span>
            <button onClick={()=>setCur(new Date(y,m+1,1))} style={{ border:'none', background:'rgba(var(--primary-rgb),0.10)', borderRadius:8, padding:'6px 10px', cursor:'pointer', display:'flex' }}><ChevronRight size={16} color="#64748b"/></button>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', gap:2, marginBottom:4 }}>
            {['Do','Lu','Ma','Mi','Ju','Vi','Sá'].map(d=><div key={d} style={{ textAlign:'center', fontSize:10, fontWeight:700, color:'#9aa5be', padding:'4px 0' }}>{d}</div>)}
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', gap:2 }}>
            {cells.map((day,i)=>{
              const isToday=day===today.getDate()&&y===today.getFullYear()&&m===today.getMonth();
              const evts=day?(byDay[day]||[]):[];
              const isSel=sel===day;
              return (
                <div key={i} onClick={()=>day&&setSel(isSel?null:day)}
                  style={{ textAlign:'center', padding:'8px 2px', borderRadius:8, fontSize:13, fontWeight:isToday?800:400, background:isToday?DS.primary:isSel?'#eef2ff':'transparent', color:isToday?'#fff':day?'#374151':'transparent', cursor:day?'pointer':'default', position:'relative', border:isSel&&!isToday?'2px solid #6366f1':'2px solid transparent', minHeight:36 }}>
                  {day}
                  {evts.length>0&&!isToday&&<div style={{ position:'absolute', bottom:3, left:'50%', transform:'translateX(-50%)', display:'flex', gap:1 }}>
                    {evts.slice(0,3).map((_,ei)=><div key={ei} style={{ width:4, height:4, borderRadius:'50%', background:DS.primary }}/>)}
                  </div>}
                </div>
              );
            })}
          </div>

          {sel && (byDay[sel]?.length??0) > 0 && (
            <div style={{ marginTop:16, paddingTop:16, borderTop:'1px solid #e2e8f0' }}>
              <div style={{ fontSize:11, fontWeight:700, color:'#9aa5be', marginBottom:10, textTransform:'uppercase' }}>
                {sel} de {cur.toLocaleDateString('es-MX',{month:'long'})}
              </div>
              {byDay[sel].map(e=>{
                const cfg=EVENT_TYPES[e.type]||EVENT_TYPES.cita;
                return (
                  <div key={e.id} style={{ display:'flex', gap:10, padding:'10px 0', borderBottom:'1px solid #e2e8f0', alignItems:'flex-start' }}>
                    <div style={{ width:34, height:34, borderRadius:8, background:e.done?'#f1f5f9':`${cfg.color}15`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}><cfg.Icon size={15} color={e.done?'#94a3b8':cfg.color}/></div>
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:13, fontWeight:700, color:e.done?'#94a3b8':'var(--dark,#0f172a)', textDecoration:e.done?'line-through':'none' }}>{e.title}</div>
                      <div style={{ fontSize:11, color:'#9aa5be' }}>{e.asesor} · {e.clientName} · {e.time}</div>
                      {e.description && <div style={{ fontSize:11, color:'#9aa5be', fontStyle:'italic', marginTop:2 }}>"{e.description}"</div>}
                    </div>
                    <div style={{ display:'flex', gap:5 }}>
                      <button onClick={ev=>toggleDone(e.id,ev)} style={{ padding:'5px 7px', borderRadius:6, border:'none', background:e.done?'#d1fae5':'#f1f5f9', cursor:'pointer', display:'flex' }}><CheckCircle size={12} color={e.done?'#10b981':'#94a3b8'}/></button>
                      <button onClick={ev=>openEdit(e,ev)} style={{ padding:'5px 7px', borderRadius:6, border:'none', background:'rgba(var(--primary-rgb),0.10)', cursor:'pointer', display:'flex' }}><Edit2 size={12} color={DS.primary}/></button>
                      <button onClick={ev=>deleteEvent(e.id,ev)} style={{ padding:'5px 7px', borderRadius:6, border:'none', background:'#fef2f2', cursor:'pointer', display:'flex' }}><Trash2 size={12} color="#ef4444"/></button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* Sidebar */}
      <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
        <button onClick={openNew} style={{ padding:'12px 0', borderRadius:12, border:'none', background:DS.primary, color:'#fff', fontWeight:700, fontSize:14, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:8 }}><Plus size={16}/> Nuevo evento</button>

        <Card title="Próximos eventos" Icon={Bell} iconColor={DS.primary}>
          {upcoming.length===0
            ? <div style={{ color:'#9aa5be', fontSize:12, textAlign:'center', padding:'12px 0' }}>Sin eventos próximos</div>
            : upcoming.slice(0,6).map(e=>{
                const cfg=EVENT_TYPES[e.type]||EVENT_TYPES.cita;
                return (
                  <div key={e.id} style={{ display:'flex', gap:10, padding:'9px 0', borderBottom:'1px solid #e2e8f0' }}>
                    <div style={{ width:32, height:32, borderRadius:8, background:`${cfg.color}15`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}><cfg.Icon size={13} color={cfg.color}/></div>
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:12, fontWeight:700, color:'var(--dark,#0f172a)' }}>{e.title}</div>
                      <div style={{ fontSize:11, color:'#9aa5be' }}>{e.asesor?.split(' ')[0]} · {e.clientName}</div>
                      <div style={{ fontSize:11, color:cfg.color, fontWeight:700 }}>{new Date(e.date).toLocaleDateString('es-MX',{weekday:'short',day:'numeric',month:'short'})} · {e.time}</div>
                      {e.description && <div style={{ fontSize:10, color:'#9aa5be', fontStyle:'italic' }}>"{e.description.substring(0,40)}{e.description.length>40?'...':''}"</div>}
                    </div>
                  </div>
                );
              })
          }
        </Card>

        <Card title="Por asesor" Icon={UserCheck}>
          {(asesores||[]).map(a=>{
            const cnt=events.filter(e=>e.asesorId===a.id&&!e.done&&new Date(e.date)>=today).length;
            return (
              <div key={a.id} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'8px 0', borderBottom:'1px solid #e2e8f0' }}>
                <span style={{ fontSize:12, fontWeight:600, color:'#4a5568' }}>{a.name.split(' ')[0]}</span>
                <span style={{ fontSize:12, fontWeight:800, color:cnt>0?DS.primary:'#94a3b8' }}>{cnt} pendientes</span>
              </div>
            );
          })}
        </Card>
      </div>

      {/* Modal nuevo/editar evento */}
      {modal && (
        <div style={{ position:'fixed', inset:0, backdropFilter:'blur(12px)', WebkitBackdropFilter:'blur(8px)', background:'rgba(var(--primary-rgb),0.35)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:9999 }}>
          <div style={{ background:'#ffffff', borderRadius:24, padding:32, width:460, boxShadow:'0 24px 64px rgba(0,0,0,0.3)' }}>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:20 }}>
              <h3 style={{ margin:0, fontSize:18, fontWeight:800, color:'var(--dark,#0f172a)' }}>{editEv?'Editar evento':'Nuevo evento'}</h3>
              <button onClick={()=>setModal(false)} style={{ border:'none', background:'none', cursor:'pointer' }}><X size={18} color="#94a3b8"/></button>
            </div>

            {/* Tipo */}
            <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:8, marginBottom:14 }}>
              {Object.entries(EVENT_TYPES).map(([k,v])=>(
                <button key={k} onClick={()=>setForm(p=>({...p,type:k}))} style={{ padding:'10px 0', borderRadius:10, border:form.type===k?`2px solid ${v.color}`:'2px solid #e2e8f0', background:form.type===k?`${v.color}15`:'#fafafa', color:form.type===k?v.color:'#9aa5be', fontWeight:700, fontSize:13, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:6 }}>
                  <v.Icon size={14}/> {v.label}
                </button>
              ))}
            </div>

            <div style={{ display:'grid', gap:10, marginBottom:14 }}>
              <input value={form.title} onChange={e=>setForm(p=>({...p,title:e.target.value}))} placeholder="Título del evento *"
                style={{ padding:'10px 14px', border:'1px solid #cbd5e1', borderRadius:10, fontSize:13, outline:'none' }}/>
              <input value={form.clientName} onChange={e=>setForm(p=>({...p,clientName:e.target.value}))} placeholder="Nombre del cliente *"
                style={{ padding:'10px 14px', border:'1px solid #cbd5e1', borderRadius:10, fontSize:13, outline:'none' }}/>
              <select value={form.asesorId} onChange={e=>setForm(p=>({...p,asesorId:e.target.value}))} style={{ padding:'10px 14px', border:'1px solid #cbd5e1', borderRadius:10, fontSize:13, outline:'none', cursor:'pointer' }}>
                {(asesores||[]).map(a=><option key={a.id} value={a.id}>{a.name}</option>)}
              </select>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                <input type="date" value={form.date} onChange={e=>setForm(p=>({...p,date:e.target.value}))} style={{ padding:'10px 14px', border:'1px solid #cbd5e1', borderRadius:10, fontSize:13, outline:'none' }}/>
                <input type="time" value={form.time} onChange={e=>setForm(p=>({...p,time:e.target.value}))} style={{ padding:'10px 14px', border:'1px solid #cbd5e1', borderRadius:10, fontSize:13, outline:'none' }}/>
              </div>
              <textarea value={form.description} onChange={e=>setForm(p=>({...p,description:e.target.value}))} placeholder="Descripción del evento (¿de qué trata?)" rows={3}
                style={{ padding:'10px 14px', border:'1px solid #cbd5e1', borderRadius:10, fontSize:13, resize:'none', outline:'none' }}/>
            </div>

            <div style={{ display:'flex', gap:10 }}>
              <Btn onClick={()=>setModal(false)} color="#64748b" bg="#f1f5f9" icon={X}>Cancelar</Btn>
              <button onClick={saveEvent} style={{ flex:1, padding:'11px 0', borderRadius:10, border:'none', background:DS.primary, color:'#fff', fontWeight:700, fontSize:13, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:6 }}><CheckCircle size={14}/> {editEv?'Guardar cambios':'Crear evento'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* ════════════════════════════════════════════════════════════════════
   TAB 5 — MENSAJES (supervisor ↔ asesores + admin)
═══════════════════════════════════════════════════════════════════ */
function TabMensajes({ users, initialContact }) {
  const [messages,  setMessages]  = useState([]);
  const [activeTo,  setActiveTo]  = useState(initialContact||null);
  const [activeRole,setActiveRole]= useState(null);
  const [text,      setText]      = useState('');
  const [loading,   setLoading]   = useState(true);
  const endRef = useRef(null);

  // Construir lista de contactos: admins + asesores
  const admins   = (users||[]).filter(u=>u.role==='admin');
  const asesores = (users||[]).filter(u=>u.role==='advisor'||u.role==='asesor');
  const contactos = [
    ...admins.map(u=>({...u, tipo:'admin',    etiqueta:'Administrador'})),
    ...asesores.map(u=>({...u, tipo:'asesor', etiqueta:'Asesor'})),
  ];

  useEffect(()=>{
    if(initialContact) {
      setActiveTo(initialContact);
    } else if(contactos.length>0 && !activeTo) {
      setActiveTo(contactos[0].id);
      setActiveRole(contactos[0].role);
    }
  },[contactos.length, initialContact]);

  useEffect(()=>{
    setLoading(true);
    apiFetch('GET','/api/supervisor/messages')
      .then(r=>{ setMessages(Array.isArray(r)?r:[]); })
      .catch(()=>setMessages([]))
      .finally(()=>setLoading(false));
  },[]);

  useEffect(()=>{ endRef.current?.scrollIntoView({behavior:'smooth'}); },[messages, activeTo]);

  async function send() {
    if(!text.trim()||!activeTo) return;
    try {
      const r = await apiFetch('POST','/api/supervisor/messages',{ toId:activeTo, texto:text.trim() });
      setMessages(p=>[...p,r]);
      setText('');
    } catch(e) { alert(e.message); }
  }

  const conv = messages.filter(m=>(m.to_id===activeTo)||(m.from_id===activeTo)).sort((a,b)=>new Date(a.created_at)-new Date(b.created_at));
  const contactoActivo = contactos.find(c=>c.id===activeTo);

  return (
    <div style={{ display:MOB?'block':'grid', gridTemplateColumns:'260px 1fr', gap:0, background:'var(--card-bg,#fff)',borderRadius:16,border:'1px solid #e5e7eb', overflow:'hidden', minHeight:520 }}>
      {/* Lista contactos */}
      {(!MOB || !activeTo) && <div style={{ borderRight:'1px solid rgba(var(--primary-rgb),0.08)', overflowY:'auto', maxHeight:MOB?240:'none' }}>
        <div style={{ padding:'14px 16px 10px', borderBottom:'1px solid #e2e8f0', fontSize:13, fontWeight:700, color:'var(--dark,#0f172a)' }}>Conversaciones</div>
        <div style={{ padding:'6px 14px', background:'#fef3c7', fontSize:10, color:'#92400e', fontWeight:600, display:'flex', alignItems:'center', gap:5 }}>
          <Eye size={10}/> Visible para el administrador
        </div>
        {/* Admins primero */}
        {admins.length>0&&<div style={{ padding:'6px 14px 4px', fontSize:9, color:'#9aa5be', fontWeight:800, textTransform:'uppercase', letterSpacing:0.5 }}>Administrador</div>}
        {admins.map(c=>{
          const unread=messages.filter(m=>m.from_id===c.id&&m.to_id!==c.id&&!m.leido).length;
          const last=[...messages].filter(m=>m.from_id===c.id||m.to_id===c.id).sort((a,b)=>new Date(b.created_at)-new Date(a.created_at))[0];
          return(
            <div key={c.id} onClick={()=>{setActiveTo(c.id);setActiveRole(c.role);}} style={{ padding:'11px 16px',display:'flex',gap:10,alignItems:'center',cursor:'pointer',background:activeTo===c.id?'#fef3c7':'transparent',borderBottom:'1px solid #e2e8f0' }}>
              <div style={{ width:36,height:36,borderRadius:'50%',background:'#fef3c7',display:'flex',alignItems:'center',justifyContent:'center',fontSize:14,fontWeight:800,color:'#d97706',flexShrink:0 }}>{(c.name||'A').charAt(0)}</div>
              <div style={{ flex:1,minWidth:0 }}>
                <div style={{ display:'flex',justifyContent:'space-between' }}>
                  <span style={{ fontSize:12,fontWeight:700,color:'var(--dark,#0f172a)' }}>{c.name.split(' ')[0]}</span>
                  {last&&<span style={{ fontSize:9,color:'#9aa5be' }}>{new Date(last.created_at).toLocaleTimeString('es-MX',{hour:'2-digit',minute:'2-digit'})}</span>}
                </div>
                <div style={{ fontSize:10,color:'#d97706',fontWeight:600 }}>Administrador</div>
              </div>
              {unread>0&&<div style={{ width:18,height:18,borderRadius:'50%',background:'#f59e0b',display:'flex',alignItems:'center',justifyContent:'center',fontSize:10,fontWeight:800,color:'#fff',flexShrink:0 }}>{unread}</div>}
            </div>
          );
        })}
        {/* Asesores */}
        {asesores.length>0&&<div style={{ padding:'8px 14px 4px', fontSize:9, color:'#9aa5be', fontWeight:800, textTransform:'uppercase', letterSpacing:0.5 }}>Asesores</div>}
        {asesores.map(c=>{
          const unread=messages.filter(m=>m.from_id===c.id&&!m.leido).length;
          const last=[...messages].filter(m=>m.from_id===c.id||m.to_id===c.id).sort((a,b)=>new Date(b.created_at)-new Date(a.created_at))[0];
          return(
            <div key={c.id} onClick={()=>{setActiveTo(c.id);setActiveRole(c.role);}} style={{ padding:'11px 16px',display:'flex',gap:10,alignItems:'center',cursor:'pointer',background:activeTo===c.id?'rgba(var(--primary-rgb),0.18)':'transparent',borderBottom:'1px solid #e2e8f0' }}>
              <div style={{ position:'relative',flexShrink:0 }}>
                <div style={{ width:36,height:36,borderRadius:'50%',background:'rgba(var(--primary-rgb),0.10)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:14,fontWeight:800,color:DS.primary }}>{(c.name||'A').charAt(0)}</div>
                <div style={{ position:'absolute',bottom:0,right:0,width:9,height:9,borderRadius:'50%',background:c.status==='active'?'#10b981':'#94a3b8',border:'2px solid #fff' }}/>
              </div>
              <div style={{ flex:1,minWidth:0 }}>
                <div style={{ display:'flex',justifyContent:'space-between' }}>
                  <span style={{ fontSize:12,fontWeight:700,color:'var(--dark,#0f172a)' }}>{c.name.split(' ')[0]}</span>
                  {last&&<span style={{ fontSize:9,color:'#9aa5be' }}>{new Date(last.created_at).toLocaleTimeString('es-MX',{hour:'2-digit',minute:'2-digit'})}</span>}
                </div>
                <div style={{ fontSize:10,color:'#9aa5be',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' }}>{last?.texto||'Sin mensajes'}</div>
              </div>
              {unread>0&&<div style={{ width:18,height:18,borderRadius:'50%',background:DS.primary,display:'flex',alignItems:'center',justifyContent:'center',fontSize:10,fontWeight:800,color:'#fff',flexShrink:0 }}>{unread}</div>}
            </div>
          );
        })}
        {contactos.length===0&&<div style={{ padding:20,textAlign:'center',color:'#9aa5be',fontSize:12 }}>Sin contactos disponibles</div>}
      </div>}

      {/* Área de chat */}
      {(!MOB || activeTo) && <div style={{ display:'flex',flexDirection:'column' }}>
        {MOB && activeTo && <button onClick={()=>setActiveTo(null)} style={{ margin:'10px 14px 0',padding:'8px 14px',background:'none',border:'1px solid #e2e8f0',borderRadius:8,fontSize:13,cursor:'pointer',textAlign:'left',color:DS.primary,fontWeight:600 }}>← Volver</button>}
        {contactoActivo?(
          <div style={{ padding:'12px 18px',borderBottom:'1px solid #e2e8f0',display:'flex',alignItems:'center',gap:10,background:'#f5f7fb' }}>
            <div style={{ width:36,height:36,borderRadius:'50%',background:contactoActivo.tipo==='admin'?'#fef3c7':'#eef2ff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:14,fontWeight:800,color:contactoActivo.tipo==='admin'?'#d97706':DS.primary }}>{(contactoActivo.name||'A').charAt(0)}</div>
            <div>
              <div style={{ fontSize:14,fontWeight:700,color:'var(--dark,#0f172a)' }}>{contactoActivo.name}</div>
              <div style={{ fontSize:11,color:'#9aa5be',fontWeight:600 }}>{contactoActivo.tipo==='admin'?'Administrador':'Asesor'}</div>
            </div>
          </div>
        ):(
          <div style={{ padding:'12px 18px',borderBottom:'1px solid #e2e8f0',background:'#f5f7fb',color:'#9aa5be',fontSize:12 }}>Selecciona un contacto</div>
        )}

        <div style={{ flex:1,overflowY:'auto',padding:'14px 18px',display:'flex',flexDirection:'column',gap:10,minHeight:280 }}>
          {loading&&<div style={{ textAlign:'center',color:'#9aa5be',fontSize:12,marginTop:40 }}>Cargando mensajes...</div>}
          {!loading&&conv.length===0&&<div style={{ color:'#9aa5be',fontSize:12,textAlign:'center',marginTop:40 }}>Sin mensajes. ¡Inicia la conversación!</div>}
          {conv.map(msg=>{
            const mine = !msg.to_id || msg.from_role==='supervisor';
            return(
              <div key={msg.id} style={{ display:'flex',justifyContent:mine?'flex-end':'flex-start' }}>
                <div style={{ maxWidth:'70%',padding:'10px 14px',borderRadius:mine?'14px 14px 4px 14px':'14px 14px 14px 4px',background:mine?DS.primary:'#f1f5f9',color:mine?'#fff':'#374151',fontSize:13,lineHeight:1.5 }}>
                  {!mine&&<div style={{ fontSize:10,fontWeight:700,color:DS.primary,marginBottom:3 }}>{msg.from_name}</div>}
                  <div>{msg.texto}</div>
                  <div style={{ fontSize:10,marginTop:4,opacity:0.7,textAlign:'right' }}>{new Date(msg.created_at).toLocaleTimeString('es-MX',{hour:'2-digit',minute:'2-digit'})}</div>
                </div>
              </div>
            );
          })}
          <div ref={endRef}/>
        </div>

        <div style={{ padding:'10px 16px',borderTop:'1px solid #e2e8f0',display:'flex',gap:10,alignItems:'flex-end' }}>
          <textarea value={text} onChange={e=>setText(e.target.value)}
            onKeyDown={e=>{if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();send();}}}
            placeholder={contactoActivo?`Escribe a ${contactoActivo.name.split(' ')[0]}... (Enter para enviar)`:'Selecciona un contacto'}
            disabled={!activeTo} rows={2}
            style={{ flex:1,padding:'9px 13px',border:'1px solid #cbd5e1',borderRadius:10,fontSize:13,resize:'none',outline:'none',background:!activeTo?'#f8fafc':'#fff' }}/>
          <button onClick={send} disabled={!activeTo||!text.trim()} style={{ padding:'12px 16px',borderRadius:10,border:'none',background:!activeTo||!text.trim()?'#f1f5f9':DS.primary,color:!activeTo||!text.trim()?'#94a3b8':'#fff',cursor:'pointer',display:'flex',alignItems:'center',gap:5,fontWeight:700 }}>
            <Send size={14}/> Enviar
          </button>
        </div>
      </div>}
    </div>
  );
}

/* ════════════════════════════════════════════════════════════════════
   TAB VENTAS — mensual/semanal/anual con descarga CSV
═══════════════════════════════════════════════════════════════════ */
const VENTAS_DATA = {
  Ene:{v:3,p:1,m:54000}, Feb:{v:5,p:2,m:90000}, Mar:{v:4,p:1,m:72000},
  Abr:{v:7,p:3,m:126000},May:{v:6,p:2,m:108000},Jun:{v:8,p:2,m:144000},
  Jul:{v:5,p:3,m:90000}, Ago:{v:9,p:1,m:162000},Sep:{v:11,p:2,m:198000},
  Oct:{v:8,p:4,m:144000},Nov:{v:12,p:2,m:216000},Dic:{v:10,p:3,m:180000},
};
const MLIST = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
const fmtMXN = n => '$'+Number(n).toLocaleString('es-MX');

function TabVentas({ clients, asesores: asesoresProp }) {
  const p = DS.primary;
  const asesores = asesoresProp || [];
  const [showMetaModal,  setShowMetaModal]  = useState(false);
  const [editTarget,     setEditTarget]     = useState(null);
  const [showGlobalEdit, setShowGlobalEdit] = useState(false);
  const [globalInput,    setGlobalInput]    = useState('');
  const [showNotif,      setShowNotif]      = useState(null);

  const { metas, metaGlobal, saveMeta: saveMetaApi, saveMetaGlobal } = useMetas(); // persiste en la BD, compartido con admin

  const saveMeta = (key,val)=>{
    saveMetaApi(key, val).catch(e=>alert('Error al guardar meta: '+e.message));
    setShowMetaModal(false);
    setShowNotif('✅ Meta actualizada');
    setTimeout(()=>setShowNotif(null),2500);
  };
  const saveGlobal = (val)=>{
    saveMetaGlobal(val).catch(e=>alert('Error al guardar meta: '+e.message));
    setShowGlobalEdit(false);
    setShowNotif('✅ Meta global guardada');
    setTimeout(()=>setShowNotif(null),2500);
  };

  const won  = clients?.filter(c=>c.result==='won') ||[];
  const lost = clients?.filter(c=>c.result==='lost')||[];
  const totalMeta = metaGlobal ||
    asesores.reduce((s,a)=>s+(metas[a.id||a.name]||10),0)||
    asesores.length*10||10;
  const pctMeta = Math.min(Math.round((won.length/totalMeta)*100),100);
  const ingresos = won.reduce((s,c)=>s+(Number(c.metadata?.saleAmount ?? c.saleAmount)||0),0);
  const fmtMXN = n=>'$'+Number(n).toLocaleString('es-MX');
  const mesNombre=['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'][new Date().getMonth()];

  const asesorData = asesores.map(a=>{
    const key=a.id||a.name;
    const mc=clients?.filter(c=>c.asesor===a.name||c.advisor_id===a.id)||[];
    const mw=mc.filter(c=>c.result==='won');
    const metaA=metas[key]||10;
    const pctA=Math.min(Math.round((mw.length/metaA)*100),100);
    return{...a,key,ganados:mw.length,perdidos:mc.filter(c=>c.result==='lost').length,
      clientes:mc.length,meta:metaA,pctMeta:pctA,
      tasa:mc.length?Math.round((mw.length/mc.length)*100):0};
  }).sort((a,b)=>b.ganados-a.ganados);

  const card={background:'var(--card-bg,#fff)',borderRadius:16,border:'1px solid #e5e7eb',
    boxShadow:'0 1px 3px rgba(0,0,0,0.05)',overflow:'hidden'};

  return(
    <div style={{fontFamily:"'DM Sans',sans-serif"}}>

      {showNotif&&(
        <div style={{position:'fixed',top:20,right:24,zIndex:99999,
          background:'var(--dark,#0f172a)',color:'#fff',borderRadius:12,padding:'12px 20px',
          boxShadow:'0 8px 24px rgba(0,0,0,0.2)',fontSize:13,fontWeight:600,
          display:'flex',alignItems:'center',gap:8}}>{showNotif}</div>
      )}

      {/* Meta modal */}
      {showMetaModal&&editTarget&&(
        <div style={{position:'fixed',inset:0,background:'rgba(15,23,42,0.5)',
          backdropFilter:'blur(4px)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}
          onClick={e=>{if(e.target===e.currentTarget)setShowMetaModal(false);}}>
          <div style={{background:'#fff',borderRadius:22,padding:30,width:420,
            boxShadow:'0 24px 60px rgba(0,0,0,0.2)',border:'1px solid #eaecf0'}}>
            <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:20}}>
              <div style={{width:46,height:46,borderRadius:'50%',background:`${p}15`,
                display:'flex',alignItems:'center',justifyContent:'center',fontSize:18,fontWeight:800,color:p}}>
                {editTarget.name?.charAt(0)?.toUpperCase()}
              </div>
              <div>
                <div style={{fontSize:16,fontWeight:800,color:'var(--dark,#0f172a)'}}>Meta de {editTarget.name}</div>
                <div style={{fontSize:12,color:'#94a3b8'}}>{mesNombre} {new Date().getFullYear()}</div>
              </div>
              <button onClick={()=>setShowMetaModal(false)} style={{marginLeft:'auto',
                border:'none',background:'#f1f5f9',borderRadius:10,padding:8,cursor:'pointer',display:'flex'}}
                onMouseEnter={e=>e.currentTarget.style.background='#e2e8f0'}
                onMouseLeave={e=>e.currentTarget.style.background='#f1f5f9'}>
                <X size={14} color="#64748b"/>
              </button>
            </div>
            <div style={{background:`${p}08`,borderRadius:12,padding:'12px 14px',marginBottom:14,border:`1px solid ${p}15`}}>
              <div style={{display:'flex',justifyContent:'space-between',marginBottom:6}}>
                <span style={{fontSize:12,fontWeight:700,color:'var(--dark,#0f172a)'}}>Progreso actual</span>
                <span style={{fontSize:13,fontWeight:800,color:p}}>{editTarget.ganados}/{editTarget.meta}</span>
              </div>
              <div style={{background:'rgba(255,255,255,0.6)',borderRadius:999,height:7,overflow:'hidden'}}>
                <div style={{width:`${editTarget.pctMeta}%`,height:'100%',
                  background:editTarget.pctMeta>=80?'#10b981':editTarget.pctMeta>=50?p:'#f59e0b',
                  borderRadius:999}}/>
              </div>
            </div>
            <input type="number" min="1" max="200" defaultValue={editTarget.meta}
              id={`meta-sup-${editTarget.key}`}
              style={{width:'100%',padding:'14px',border:'2px solid #e2e8f0',borderRadius:12,
                fontSize:28,fontWeight:800,textAlign:'center',color:'var(--dark,#0f172a)',outline:'none',
                boxSizing:'border-box',marginBottom:12,transition:'border .2s'}}
              onFocus={e=>e.target.style.borderColor=p}
              onBlur={e=>e.target.style.borderColor='#e2e8f0'}/>
            <div style={{display:'flex',gap:6,flexWrap:'wrap',marginBottom:14}}>
              {[5,8,10,12,15,20].map(n=>(
                <button key={n} onClick={()=>{document.getElementById(`meta-sup-${editTarget.key}`).value=n;}}
                  style={{padding:'5px 12px',borderRadius:8,border:`1.5px solid ${p}20`,
                    background:`${p}08`,color:p,fontSize:12,fontWeight:700,cursor:'pointer',transition:'all .15s'}}
                  onMouseEnter={e=>{e.currentTarget.style.background=p;e.currentTarget.style.color='#fff';}}
                  onMouseLeave={e=>{e.currentTarget.style.background=`${p}08`;e.currentTarget.style.color=p;}}>
                {n}
              </button>
            ))}
          </div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
            <button onClick={()=>setShowMetaModal(false)}
              style={{padding:'12px',borderRadius:12,border:'1.5px solid #e2e8f0',
                background:'#f8fafc',color:'#64748b',fontWeight:700,fontSize:13,cursor:'pointer'}}
              onMouseEnter={e=>e.currentTarget.style.background='#e2e8f0'}
              onMouseLeave={e=>e.currentTarget.style.background='#f8fafc'}>Cancelar</button>
            <button onClick={()=>saveMeta(editTarget.key,document.getElementById(`meta-sup-${editTarget.key}`).value)}
              style={{padding:'12px',borderRadius:12,border:'none',
                background:`linear-gradient(135deg,${p},${p}cc)`,color:'#fff',
                fontWeight:800,fontSize:13,cursor:'pointer',boxShadow:`0 4px 14px ${p}35`,transition:'all .2s'}}
              onMouseEnter={e=>e.currentTarget.style.transform='translateY(-1px)'}
              onMouseLeave={e=>e.currentTarget.style.transform=''}>Guardar meta</button>
          </div>
        </div>
      </div>
      )}

      {/* Header */}
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:22}}>
        <div>
          <h1 style={{margin:0,fontSize:MOB?22:28,fontWeight:800,color:NAVY,letterSpacing:'-0.5px'}}>Ventas del Equipo</h1>
          <p style={{margin:'4px 0 0',fontSize:14,color:'#64748b'}}>{mesNombre} · {asesores.length} asesores</p>
        </div>
        <button onClick={()=>{setGlobalInput(String(totalMeta));setShowGlobalEdit(true);}}
          style={{padding:'9px 18px',borderRadius:11,border:`1.5px solid ${p}30`,
            background:`${p}08`,color:p,fontSize:12,fontWeight:700,cursor:'pointer',
            display:'flex',alignItems:'center',gap:6,transition:'all .2s'}}
          onMouseEnter={e=>{e.currentTarget.style.background=p;e.currentTarget.style.color='#fff';}}
          onMouseLeave={e=>{e.currentTarget.style.background=`${p}08`;e.currentTarget.style.color=p;}}>
          <Star size={13}/> Meta del equipo
        </button>
      </div>

      {/* Global meta banner */}
      {showGlobalEdit&&(
        <div style={{background:NAVY,borderRadius:16,
          padding:'20px 24px',marginBottom:20,color:'#fff',
          display:'flex',alignItems:'center',gap:16}}>
          <div style={{flex:1}}>
            <div style={{fontSize:13,fontWeight:800,marginBottom:4}}>Meta total del equipo — {mesNombre}</div>
            <div style={{fontSize:11,color:'rgba(255,255,255,0.7)'}}>O asigna metas individuales a cada asesor en la tabla de abajo.</div>
          </div>
          <input type="number" value={globalInput} onChange={e=>setGlobalInput(e.target.value)}
            style={{width:90,padding:'10px',border:'2px solid rgba(255,255,255,0.4)',
              borderRadius:10,fontSize:22,fontWeight:800,textAlign:'center',
              background:'rgba(255,255,255,0.15)',color:'#fff',outline:'none',boxSizing:'border-box'}}/>
          <button onClick={()=>saveGlobal(globalInput)}
            style={{padding:'10px 20px',borderRadius:10,border:'none',
              background:'rgba(255,255,255,0.25)',color:'#fff',fontWeight:800,fontSize:13,cursor:'pointer'}}
            onMouseEnter={e=>e.currentTarget.style.background='rgba(255,255,255,0.35)'}
            onMouseLeave={e=>e.currentTarget.style.background='rgba(255,255,255,0.25)'}>Guardar</button>
          <button onClick={()=>setShowGlobalEdit(false)}
            style={{padding:'10px 16px',borderRadius:10,border:'1.5px solid rgba(255,255,255,0.3)',
              background:'transparent',color:'rgba(255,255,255,0.7)',fontWeight:700,fontSize:13,cursor:'pointer'}}>Cancelar</button>
        </div>
      )}

      {/* KPIs con META card destacada */}
      <div style={{display:'grid',gridTemplateColumns:MOB?'repeat(2,1fr)':'1.2fr 1fr 1fr 1fr',gap:14,marginBottom:20}}>
        {/* META card */}
        <div style={{background:NAVY,borderRadius:16,
          padding:'20px',color:'#fff',position:'relative',overflow:'hidden',cursor:'pointer',transition:'all .2s'}}
          onClick={()=>setShowGlobalEdit(!showGlobalEdit)}
          onMouseEnter={e=>{e.currentTarget.style.transform='translateY(-2px)';e.currentTarget.style.boxShadow=`0 14px 36px ${p}45`;}}
          onMouseLeave={e=>{e.currentTarget.style.transform='';e.currentTarget.style.boxShadow=`0 8px 28px ${p}35`;}}>
          <div style={{position:'absolute',top:-30,right:-30,width:100,height:100,borderRadius:'50%',background:'rgba(255,255,255,0.1)',pointerEvents:'none'}}/>
          <div style={{position:'relative'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:10}}>
              <div style={{width:38,height:38,borderRadius:10,background:'rgba(255,255,255,0.2)',display:'flex',alignItems:'center',justifyContent:'center'}}><Target size={18} color="#fff"/></div>
              <span style={{fontSize:9,color:'rgba(255,255,255,0.7)',background:'rgba(255,255,255,0.15)',borderRadius:999,padding:'2px 8px',fontWeight:700}}>Editar</span>
            </div>
            <div style={{fontSize:10,color:'rgba(255,255,255,0.75)',fontWeight:700,marginBottom:3,textTransform:'uppercase',letterSpacing:0.5}}>Meta del mes</div>
            <div style={{fontSize:36,fontWeight:900,lineHeight:1,marginBottom:3}}>{totalMeta}</div>
            <div style={{fontSize:11,color:'rgba(255,255,255,0.7)',marginBottom:10}}>ventas objetivo</div>
            <div style={{background:'rgba(255,255,255,0.2)',borderRadius:999,height:7,overflow:'hidden',marginBottom:5}}>
              <div style={{width:`${pctMeta}%`,height:'100%',background:'#fff',borderRadius:999,transition:'width .8s ease'}}/>
            </div>
            <div style={{display:'flex',justifyContent:'space-between',fontSize:10,color:'rgba(255,255,255,0.7)'}}>
              <span>{won.length} logradas</span><span>{pctMeta}%</span>
            </div>
          </div>
        </div>
        {[
          {Icon:Trophy,    l:'Ventas cerradas',  v:won.length,         c:'#10b981',sub:'mi equipo'},
          {Icon:DollarSign,l:'Ingresos est.',     v:fmtMXN(ingresos),  c:'#f59e0b',sub:'generados',sm:true},
          {Icon:BarChart2, l:'Conversión',        v:`${clients?.length?Math.round((won.length/clients.length)*100):0}%`,c:'#8b5cf6',sub:'tasa del equipo'},
        ].map((k,i)=>(
          <div key={i} style={{background:'#fff',borderRadius:16,padding:'18px',border:'1px solid #eaecf0',boxShadow:'0 1px 3px rgba(0,0,0,0.05)',transition:'all .2s'}}
            onMouseEnter={e=>{e.currentTarget.style.transform='translateY(-2px)';e.currentTarget.style.boxShadow=`0 8px 24px ${k.c}18`;}}
            onMouseLeave={e=>{e.currentTarget.style.transform='';e.currentTarget.style.boxShadow='0 1px 3px rgba(0,0,0,0.05)';}}>
            <div style={{display:'flex',justifyContent:'space-between',marginBottom:12}}>
              <div style={{width:38,height:38,borderRadius:10,background:`${k.c}12`,border:'1px solid #e5e7eb',display:'flex',alignItems:'center',justifyContent:'center'}}><k.Icon size={17} color={k.c} strokeWidth={2}/></div>
            </div>
            <div style={{fontSize:k.sm?16:26,fontWeight:800,color:'var(--dark,#0f172a)',lineHeight:1,marginBottom:3}}>{k.v}</div>
            <div style={{fontSize:11,fontWeight:700,color:'var(--dark,#0f172a)',marginBottom:2}}>{k.l}</div>
            <div style={{fontSize:10,color:'#94a3b8'}}>{k.sub}</div>
          </div>
        ))}
      </div>

      {/* Tabla metas individuales */}
      <div style={{...card,overflowX:'auto'}}>
        <div style={{padding:'14px 20px',borderBottom:'1px solid #f1f5f9',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <div style={{display:'flex',alignItems:'center',gap:8}}>
            <UserCheck size={14} color={p}/>
            <div>
              <div style={{fontSize:14,fontWeight:800,color:'var(--dark,#0f172a)'}}>Metas individuales de mis asesores</div>
              <div style={{fontSize:11,color:'#94a3b8'}}>Haz clic en "Meta" para editar la meta de cada asesor</div>
            </div>
          </div>
          <div style={{fontSize:11,color:'#94a3b8'}}>Meta total: <b style={{color:p}}>{totalMeta}</b> · Logrado: <b style={{color:'#10b981'}}>{won.length}</b></div>
        </div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 70px 70px 70px 150px 80px',minWidth:560,gap:10,padding:'10px 20px',background:'#f8fafc',borderBottom:'1px solid #f1f5f9'}}>
          {['Asesor','Clientes','Ganados','Tasa','Progreso meta','Acción'].map((h,i)=>(
            <div key={i} style={{fontSize:9,fontWeight:700,color:'#94a3b8',letterSpacing:0.5,textAlign:i>0?'center':'left'}}>{h}</div>
          ))}
        </div>
        {asesorData.length===0&&<div style={{padding:'24px',textAlign:'center',color:'#94a3b8',fontSize:13}}>Sin asesores en tu equipo</div>}
        {asesorData.map((a,i)=>(
          <div key={a.key||i}
            style={{display:'grid',gridTemplateColumns:'1fr 70px 70px 70px 150px 80px',minWidth:560,gap:10,padding:'13px 20px',borderBottom:'1px solid #f8fafc',alignItems:'center',transition:'background .15s'}}
            onMouseEnter={e=>e.currentTarget.style.background='#f8fafc'}
            onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
            <div style={{display:'flex',alignItems:'center',gap:9}}>
              <div style={{width:34,height:34,borderRadius:'50%',background:`${p}15`,border:`2px solid ${p}20`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:13,fontWeight:800,color:p,flexShrink:0}}>{a.name?.charAt(0)?.toUpperCase()}</div>
              <div>
                <div style={{fontSize:13,fontWeight:700,color:'var(--dark,#0f172a)'}}>{a.name}</div>
                <div style={{fontSize:10,color:'#94a3b8'}}>Meta: {a.meta} ventas</div>
              </div>
            </div>
            <div style={{textAlign:'center',fontSize:13,fontWeight:700,color:'#64748b'}}>{a.clientes}</div>
            <div style={{textAlign:'center',fontSize:14,fontWeight:800,color:'#10b981'}}>{a.ganados}</div>
            <div style={{textAlign:'center'}}>
              <span style={{fontSize:11,fontWeight:800,padding:'3px 9px',borderRadius:999,
                color:a.tasa>=60?'#10b981':a.tasa>=30?'#f59e0b':'#ef4444',
                background:a.tasa>=60?'#f0fdf9':a.tasa>=30?'#fffbeb':'#fef2f2'}}>{a.tasa}%</span>
            </div>
            <div style={{padding:'0 2px'}}>
              <div style={{display:'flex',justifyContent:'space-between',marginBottom:4}}>
                <span style={{fontSize:10,color:'#94a3b8'}}>{a.ganados}/{a.meta}</span>
                <span style={{fontSize:10,fontWeight:800,color:a.pctMeta>=80?'#10b981':a.pctMeta>=50?p:'#f59e0b'}}>{a.pctMeta}%</span>
              </div>
              <div style={{background:'#f1f5f9',borderRadius:999,height:7,overflow:'hidden'}}>
                <div style={{width:`${a.pctMeta}%`,height:'100%',
                  background:a.pctMeta>=80?'#10b981':a.pctMeta>=50?p:'#f59e0b',
                  borderRadius:999,transition:'width .5s ease'}}/>
              </div>
              {a.pctMeta>=100&&<div style={{fontSize:9,color:'#10b981',fontWeight:700,marginTop:2,textAlign:'center'}}>¡Meta cumplida!</div>}
            </div>
            <div style={{textAlign:'center'}}>
              <button onClick={()=>{setEditTarget(a);setShowMetaModal(true);}}
                style={{padding:'6px 12px',borderRadius:8,border:`1.5px solid ${p}30`,
                  background:`${p}08`,color:p,fontSize:11,fontWeight:700,cursor:'pointer',
                  display:'inline-flex',alignItems:'center',gap:4,transition:'all .15s'}}
                onMouseEnter={e=>{e.currentTarget.style.background=p;e.currentTarget.style.color='#fff';e.currentTarget.style.borderColor=p;}}
                onMouseLeave={e=>{e.currentTarget.style.background=`${p}08`;e.currentTarget.style.color=p;e.currentTarget.style.borderColor=`${p}30`;}}>
                <Star size={10}/> Meta
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function TabReportes({ clients, asesores = [], teamActivities = [] }) {
  const [range, setRange] = useState('month');

  const ganados = clients.filter(c=>c.result==='won').length;
  const perdidos= clients.filter(c=>c.result==='lost').length;
  const total   = clients.length;
  const conv    = total?Math.round((ganados/total)*100):0;

  // Tiempo promedio real de actividad (a partir de duraciones registradas por los asesores)
  const durs    = teamActivities.map(a=>Number(a.duration)||0).filter(d=>d>0);
  const avgCall = durs.length ? Math.round(durs.reduce((s,d)=>s+d,0)/durs.length) : 0;

  // Clientes nuevos por mes (real, según created_at de los clientes que registran los asesores)
  const monthly = Array(12).fill(0);
  clients.forEach(c=>{ const d=new Date(c.created_at||c.last_contact); if(!isNaN(d)) monthly[d.getMonth()]++; });
  const monthTotal = monthly.reduce((a,b)=>a+b,0);
  const cm = new Date().getMonth();
  const tendencia = (cm>0 && monthly[cm-1]) ? Math.round(((monthly[cm]-monthly[cm-1])/monthly[cm-1])*100) : 0;

  const lossReasons = clients.filter(c=>c.result==='lost'&&c.lossReason).map(c=>c.lossReason);
  const reasonCounts = {};
  lossReasons.forEach(r=>{ reasonCounts[r]=(reasonCounts[r]||0)+1; });

  function exportCSV() {
    const rows = [
      ['Nombre','Teléfono','Email','Asesor','Clasificación','Estado','Razón de pérdida'],
      ...clients.map(c=>[c.name,c.phone,c.email||'',c.asesor,c.classification,c.result||'proceso',c.lossReason||''])
    ];
    const csv = rows.map(r=>r.join(',')).join('\n');
    const blob = new Blob([csv],{type:'text/csv'});
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a'); a.href=url; a.download='reporte_clientes.csv'; a.click();
  }

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:20 }}>

      {/* Header acciones */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <div style={{ display:'flex', gap:8 }}>
          {['week','month','quarter','year'].map(r=>(
            <button key={r} onClick={()=>setRange(r)} style={{ padding:'7px 14px', borderRadius:8, border:'none', fontSize:12, fontWeight:700, cursor:'pointer', background:range===r?NAVY:'#fff',color:range===r?'#fff':'#475569',boxShadow:'inset 0 0 0 1px #e5e7eb' }}>
              {{week:'Esta semana',month:'Este mes',quarter:'Trimestre',year:'Año'}[r]}
            </button>
          ))}
        </div>
        <button onClick={exportCSV} style={{ padding:'9px 16px', borderRadius:10, border:'none', background:'#10b981', color:'#fff', fontWeight:700, fontSize:13, cursor:'pointer', display:'flex', alignItems:'center', gap:6 }}><Download size={14}/> Exportar CSV</button>
      </div>

      {/* KPIs */}
      <div style={{ display:'grid', gridTemplateColumns:MOB?'repeat(2,1fr)':'repeat(5,1fr)', gap:14 }}>
        {[
          { Icon:Users,     label:'Total clientes',     value:total,   color:DS.primary },
          { Icon:Trophy,    label:'Ganados',             value:ganados, color:'#10b981' },
          { Icon:XCircle,   label:'Perdidos',            value:perdidos,color:'#ef4444' },
          { Icon:BarChart2, label:'Tasa de conversión',  value:`${conv}%`,color:'#8b5cf6' },
          { Icon:Clock,     label:'Tiempo prom. actividad',value:avgCall?fmt(avgCall):'—',  color:'#f59e0b' },
        ].map((s,i)=>(
          <div key={i} style={{ background:'var(--card-bg,#fff)', borderRadius:16, padding:'16px 18px', border:'1px solid #e5e7eb' }}>
            <s.Icon size={20} color={s.color} strokeWidth={1.8}/>
            <div style={{ fontSize:26, fontWeight:800, color:'var(--dark,#0f172a)', marginTop:8 }}>{s.value}</div>
            <div style={{ fontSize:11, color:'#9aa5be', marginTop:2 }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Gráficos */}
      <div style={{ display:'grid', gridTemplateColumns:MOB?'1fr':'1.6fr 1fr', gap:16 }}>
        <Card title="Clientes nuevos por mes" Icon={TrendingUp} action={<span style={{ fontSize:11, color:'#9aa5be' }}>{new Date().getFullYear()}</span>}>
          <BarMini data={monthly} labels={MONTHS} color={DS.primary}/>
          <div style={{ marginTop:12, display:'grid', gridTemplateColumns:MOB?'repeat(2,1fr)':'repeat(4,1fr)', gap:8 }}>
            {[
              { l:'Total acumulado', v:monthTotal, c:DS.primary },
              { l:'Mejor mes',       v:Math.max(...monthly),          c:'#10b981' },
              { l:'Promedio',        v:Math.round(monthTotal/12), c:'#f59e0b' },
              { l:'Tendencia',       v:`${tendencia>=0?'↑ +':'↓ '}${tendencia}%`, c:tendencia>=0?'#10b981':'#ef4444' },
            ].map((s,i)=>(
              <div key={i} style={{ background:'#f5f7fb', borderRadius:8, padding:'8px 10px', textAlign:'center' }}>
                <div style={{ fontSize:16, fontWeight:800, color:s.c }}>{s.v}</div>
                <div style={{ fontSize:10, color:'#9aa5be' }}>{s.l}</div>
              </div>
            ))}
          </div>
        </Card>

        <Card title="Razones de pérdida" Icon={XCircle} iconColor="#ef4444">
          {Object.entries(reasonCounts).length===0
            ? <div style={{ color:'#9aa5be', fontSize:12, textAlign:'center', padding:'20px 0' }}>Sin razones registradas</div>
            : Object.entries(reasonCounts).map(([reason,count],i)=>(
              <div key={i} style={{ marginBottom:12 }}>
                <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4, fontSize:12, fontWeight:600, color:'#4a5568' }}>
                  <span style={{ flex:1, marginRight:8, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{reason}</span>
                  <span style={{ color:'#ef4444', fontWeight:800 }}>{count}</span>
                </div>
                <div style={{ background:'#fee2e2', borderRadius:999, height:7 }}>
                  <div style={{ width:`${(count/perdidos)*100}%`, height:'100%', background:'#ef4444', borderRadius:999 }}/>
                </div>
              </div>
            ))
          }
        </Card>
      </div>

      {/* Performance por asesor */}
      <Card title="Performance completo por asesor" Icon={Activity} noPad
        action={<button onClick={exportCSV} style={{ fontSize:11, color:DS.primary, fontWeight:700, border:'none', background:'rgba(var(--primary-rgb),0.10)', borderRadius:6, padding:'4px 10px', cursor:'pointer', display:'flex', alignItems:'center', gap:4 }}><Download size={11}/> Exportar</button>}>
        <div style={{overflowX:'auto'}}>
        <table style={{ width:'100%', borderCollapse:'collapse', minWidth:680 }}>
          <thead>
            <tr style={{borderBottom:'1px solid #eef0f3'}}>
              {['Asesor','Clientes','Ganados','Perdidos','Conv.%','Activ.','Prom. dur.','Racha','Score'].map(h=>(
                <th key={h} style={{ padding:'10px 14px', textAlign:'left', fontSize:12,fontWeight:600,color:'#94a3b8' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {asesores.length===0 && <tr><td colSpan={9} style={{ padding:28, textAlign:'center', color:'#9aa5be', fontSize:13 }}>Sin asesores registrados</td></tr>}
            {[...asesores].sort((a,b)=>(b.score||0)-(a.score||0)).map(a=>{
              const conv=(a.clients||0)?Math.round(((a.won||0)/a.clients)*100):0;
              const acts=teamActivities.filter(x=>x.advisor_name===a.name);
              const aDurs=acts.map(x=>Number(x.duration)||0).filter(d=>d>0);
              const avgDur=aDurs.length?Math.round(aDurs.reduce((s,d)=>s+d,0)/aDurs.length):0;
              return (
                <tr key={a.id} style={{ borderTop:'1px solid #e2e8f0' }}>
                  <td style={{ padding:'12px 14px' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:7 }}>
                      <div style={{ width:8, height:8, borderRadius:'50%', background:a.active?'#10b981':'#94a3b8' }}/>
                      <div>
                        <div style={{ fontSize:13, fontWeight:700, color:'var(--dark,#0f172a)' }}>{a.name}</div>
                        <div style={{ fontSize:10, color:'#9aa5be' }}>{a.email}</div>
                      </div>
                    </div>
                  </td>
                  <td style={{ padding:'12px 14px', fontSize:13, fontWeight:600, color:'#4a5568', textAlign:'center' }}>{a.clients||0}</td>
                  <td style={{ padding:'12px 14px', fontSize:13, fontWeight:700, color:'#10b981', textAlign:'center' }}>{a.won||0}</td>
                  <td style={{ padding:'12px 14px', fontSize:13, fontWeight:700, color:'#ef4444', textAlign:'center' }}>{a.lost||0}</td>
                  <td style={{ padding:'12px 14px', textAlign:'center' }}>
                    <span style={{ fontSize:12, fontWeight:800, color:conv>=50?'#10b981':'#ef4444' }}>{conv}%</span>
                  </td>
                  <td style={{ padding:'12px 14px', fontSize:13, color:'#4a5568', textAlign:'center' }}>{acts.length}</td>
                  <td style={{ padding:'12px 14px', fontSize:13, color:DS.primary, fontWeight:600, textAlign:'center' }}>{avgDur?fmt(avgDur):'—'}</td>
                  <td style={{ padding:'12px 14px', textAlign:'center', fontSize:12, color:'#9aa5be' }}>—</td>
                  <td style={{ padding:'12px 14px', textAlign:'center' }}><ScoreBadge score={a.score}/></td>
                </tr>
              );
            })}
          </tbody>
        </table>
        </div>
      </Card>
    </div>
  );
}

/* ════════════════════════════════════════════════════════════════════
   COMPONENTE PRINCIPAL
═══════════════════════════════════════════════════════════════════ */
/* ════════════════════════════════════════════════════════════════════
   TAB LEADS — Supervisor (Kanban + reasignar asesor)
═══════════════════════════════════════════════════════════════════ */

/* ════════════════════════════════════════════
   PIPELINE — SUPERVISOR
   Ve el equipo de asesores a su cargo
════════════════════════════════════════════ */

function TabEstadisticasPersonales({stats, leads, clients, events, onNavigate}) {
  const p = DS.primary;
  const nav = onNavigate || (()=>{});
const [hov, setHov] = React.useState(null);

  const ganados    = clients.filter(c=>c.result==='won'||c.metadata?.result==='won').length;
  const enProceso  = clients.filter(c=>!c.result&&c.metadata?.result!=='won'&&c.metadata?.result!=='lost').length;
  const totalC     = clients.length || 1;
  const tasa       = Math.round((ganados/totalC)*100);
  const calientes  = leads.filter(l=>l.nivel==='caliente').length;
  const tibios     = leads.filter(l=>l.nivel==='tibio').length;
  const frios      = leads.filter(l=>l.nivel==='frio').length;
  const totalLeads = leads.length || 1;
  const meta       = 20;
  const avance     = Math.min(Math.round((ganados/meta)*100),100);
  const scorePromedio = leads.length ? Math.round(leads.reduce((s,l)=>s+(l.score||0),0)/leads.length) : 0;

  const kpis = [
    { l:'Clientes equipo',   v:clients.length, c:DS.primary, sub:'total asignados',  nav:'clients',  Ic:Users,       bg:'#EEF2FF' },
    { l:'Ventas cerradas',   v:ganados,         c:'#10b981', sub:'este mes',          nav:'clients',  Ic:CheckCircle, bg:'#F0FDF4' },
    { l:'En negociación',    v:enProceso,       c:'#f59e0b', sub:'en proceso',        nav:'clients',  Ic:TrendingUp,  bg:'#FFFBEB' },
    { l:'Tasa conversión',   v:`${tasa}%`,      c:'#8b5cf6', sub:'del equipo',        nav:'clients',  Ic:Activity,    bg:'#F5F3FF' },
    { l:'Leads del bot',     v:leads.length,    c:'#ef4444', sub:'recibidos',         nav:'leads',    Ic:Bot,         bg:'#FFF1F2' },
    { l:'Leads calientes',   v:calientes,       c:'#ef4444', sub:'alta prioridad',    nav:'leads',    Ic:Zap,         bg:'#FFF1F2' },
    { l:'Score promedio',    v:scorePromedio,   c:'#0ea5e9', sub:'de leads',          nav:'leads',    Ic:Activity,    bg:'#EFF6FF' },
    { l:'Citas próximas',    v:events.filter(e=>new Date(e.date||e.event_date)>=new Date()).length, c:'#f59e0b', sub:'agendadas', nav:'calendar', Ic:Calendar, bg:'#FFFBEB' },
  ];

  const nivelData = [
    { l:'Calientes', v:calientes, c:'#ef4444', nav:'leads' },
    { l:'Tibios',    v:tibios,    c:'#f59e0b', nav:'leads' },
    { l:'Fríos',     v:frios,     c:DS.primary, nav:'leads' },
  ];

  return (
    <div style={{fontFamily:"'DM Sans',sans-serif"}}>
      <div style={{display:'flex',justifyContent:'flex-end',marginBottom:12}}>
      </div>

      <div style={{marginBottom:24}}>
        <h1 style={{margin:0,fontSize:MOB?22:28,fontWeight:800,color:NAVY,letterSpacing:'-0.5px'}}>Mi Rendimiento</h1>
        <p style={{margin:'4px 0 0',fontSize:14,color:'#64748b'}}>Haz clic en cada card para ver el detalle</p>
      </div>

      <div style={{display:'grid',gridTemplateColumns:MOB?'repeat(2,1fr)':'repeat(4,1fr)',gap:14,marginBottom:24}}>
        {kpis.map((k,i)=>(
          <div key={i} onClick={()=>nav(k.nav)} onMouseEnter={()=>setHov(i)} onMouseLeave={()=>setHov(null)}
            style={{background:'#fff',borderRadius:16,padding:'20px',border:'1px solid #e5e7eb',cursor:'pointer',transition:'all .2s',
              transform:hov===i?'translateY(-4px)':'none',boxShadow:hov===i?`0 12px 28px ${k.c}25`:'0 1px 4px rgba(0,0,0,0.05)',position:'relative',overflow:'hidden'}}>
            <div style={{position:'absolute',bottom:-8,right:-8,opacity:0.06}}><k.Ic size={64} color={k.c}/></div>
            <div style={{width:40,height:40,borderRadius:12,background:k.bg,display:'flex',alignItems:'center',justifyContent:'center',marginBottom:14,border:'1px solid #e5e7eb'}}>
              <k.Ic size={18} color={k.c}/>
            </div>
            <div style={{fontSize:28,fontWeight:800,color:'var(--dark,#0f172a)',lineHeight:1,marginBottom:4}}>{k.v}</div>
            <div style={{fontSize:12,fontWeight:700,color:'#475569'}}>{k.l}</div>
            <div style={{fontSize:11,color:k.c,marginTop:4,fontWeight:600}}>{k.sub} →</div>
          </div>
        ))}
      </div>

      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:16}}>
        <div style={{background:'#fff',borderRadius:16,padding:'22px',border:'1px solid #eaecf0',cursor:'pointer',transition:'all .2s'}}
          onClick={()=>nav('clients')}
          onMouseEnter={e=>{e.currentTarget.style.boxShadow=`0 8px 24px ${p}15`;e.currentTarget.style.transform='translateY(-2px)';}}
          onMouseLeave={e=>{e.currentTarget.style.boxShadow='none';e.currentTarget.style.transform='none';}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:16}}>
            <div>
              <div style={{fontSize:13,fontWeight:800,color:'var(--dark,#0f172a)',marginBottom:2}}>Meta del mes — Equipo</div>
              <div style={{fontSize:12,color:'#94a3b8'}}>Ventas cerradas este mes</div>
            </div>
            <div style={{textAlign:'right'}}>
              <div style={{fontSize:28,fontWeight:800,color:ganados>=meta?'#10b981':p,lineHeight:1}}>{ganados}</div>
              <div style={{fontSize:11,color:'#94a3b8'}}>de {meta} meta</div>
            </div>
          </div>
          <div style={{background:'#f1f5f9',borderRadius:999,height:12,overflow:'hidden',marginBottom:8}}>
            <div style={{width:`${avance}%`,height:'100%',background:avance>=100?'linear-gradient(90deg,#10b981,#34d399)':`linear-gradient(90deg,${p},${p}cc)`,borderRadius:999,transition:'width .8s'}}/>
          </div>
          <div style={{display:'flex',justifyContent:'space-between'}}>
            <span style={{fontSize:11,color:'#94a3b8'}}>{avance>=100?'Meta cumplida':avance>=60?'Buen ritmo':'Sigue adelante'}</span>
            <span style={{fontSize:13,fontWeight:800,color:avance>=100?'#10b981':p}}>{avance}%</span>
          </div>
        </div>

        <div style={{background:'#fff',borderRadius:16,padding:'22px',border:'1px solid #eaecf0'}}>
          <div style={{fontSize:13,fontWeight:800,color:'var(--dark,#0f172a)',marginBottom:16}}>Distribución de leads</div>
          {nivelData.map((n,i)=>{
            const pct=Math.round((n.v/totalLeads)*100);
            return(
              <div key={i} style={{marginBottom:12,cursor:'pointer'}} onClick={()=>nav(n.nav)}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:5}}>
                  <div style={{display:'flex',alignItems:'center',gap:8}}>
                    <div style={{width:10,height:10,borderRadius:'50%',background:n.c}}/>
                    <span style={{fontSize:12,fontWeight:600,color:'#475569'}}>{n.l}</span>
                  </div>
                  <span style={{fontSize:12,fontWeight:800,color:n.c}}>{n.v} ({pct}%)</span>
                </div>
                <div style={{background:'#f1f5f9',borderRadius:999,height:7,overflow:'hidden'}}>
                  <div style={{width:`${pct}%`,height:'100%',background:n.c,borderRadius:999}}/>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div style={{display:'grid',gridTemplateColumns:MOB?'repeat(2,1fr)':'repeat(3,1fr)',gap:12}}>
        {[
          {l:'Score promedio',   v:`${scorePromedio}/100`, c:DS.primary, sub:'de tus leads',  nav:'leads',    Ic:Activity},
          {l:'Leads hoy',        v:leads.filter(l=>new Date(l.created_at).toDateString()===new Date().toDateString()).length, c:'#f59e0b', sub:'del bot', nav:'leads', Ic:Zap},
          {l:'Citas hoy',        v:events.filter(e=>(e.date||e.event_date)===new Date().toISOString().split('T')[0]).length, c:'#10b981', sub:'agendadas', nav:'calendar', Ic:Calendar},
        ].map((s,i)=>(
          <div key={i} onClick={()=>nav(s.nav)}
            style={{background:'var(--card-bg,#fff)',borderRadius:14,padding:'18px',border:'1px solid #e5e7eb',cursor:'pointer',textAlign:'center',transition:'all .2s'}}
            onMouseEnter={e=>{e.currentTarget.style.transform='translateY(-3px)';e.currentTarget.style.boxShadow=`0 8px 20px ${s.c}20`;}}
            onMouseLeave={e=>{e.currentTarget.style.transform='none';e.currentTarget.style.boxShadow='none';}}>
            <s.Ic size={20} color={s.c} style={{marginBottom:8}}/>
            <div style={{fontSize:24,fontWeight:800,color:s.c}}>{s.v}</div>
            <div style={{fontSize:12,fontWeight:700,color:'var(--dark,#0f172a)',marginTop:4}}>{s.l}</div>
            <div style={{fontSize:11,color:'#94a3b8',marginTop:2}}>{s.sub}</div>
          </div>
        ))}
      </div>
    </div>
  );
}


function TabRendimientoEquipo({ clients, asesores: asesoresRaw, leads, teamActivities }) {
  const p = DS.primary;
  const asesores = (asesoresRaw && asesoresRaw.length > 0) ? asesoresRaw : [];
  const acts = Array.isArray(teamActivities) ? teamActivities : [];
  const [orden, setOrden] = React.useState('conversion');

  const dataAsesores = asesores.map(a => {
    const ac       = clients.filter(c => c.asesorId===a.id || c.assigned_advisor_id===a.id);
    const leadsA   = leads.filter(l => l.advisor_id===a.id);
    const ganados  = ac.filter(c => c.result==='won').length;
    const perdidos = ac.filter(c => c.result==='lost').length;
    const proceso  = ac.filter(c => !c.result).length;
    const conv     = ac.length ? Math.round((ganados/ac.length)*100) : 0;
    const calientes = leadsA.filter(l => l.nivel==='caliente').length;
    // Gestión: % de clientes asignados con los que el asesor ha tenido actividad registrada
    const actsA           = acts.filter(t => t.advisor_id===a.id);
    const clientesGestion = new Set(actsA.map(t => t.client_id).filter(Boolean)).size;
    const gestion         = ac.length ? Math.min(100, Math.round((clientesGestion/ac.length)*100)) : 0;
    return { ...a, total_clientes:ac.length, ganados, perdidos, proceso, conv, leads:leadsA.length, calientes, gestion, totalActs:actsA.length, clientesGestion };
  });

  const sorted = [...dataAsesores].sort((a,b) => {
    if (orden==='conversion') return b.conv - a.conv;
    if (orden==='gestion')    return b.gestion - a.gestion;
    if (orden==='clientes')   return b.total_clientes - a.total_clientes;
    return 0;
  });

  // Totales equipo
  const totalGanados  = dataAsesores.reduce((s,a)=>s+a.ganados,0);
  const totalClientes = dataAsesores.reduce((s,a)=>s+a.total_clientes,0)||1;
  const convEquipo    = Math.round((totalGanados/totalClientes)*100);
  const gestionEquipo = dataAsesores.length ? Math.round(dataAsesores.reduce((s,a)=>s+a.gestion,0)/dataAsesores.length) : 0;

  const tone = v => v>=60?'#10b981':v>=30?'#f59e0b':'#ef4444';

  return (
    <div>
      {/* KPIs del equipo */}
      <div style={{display:'grid',gridTemplateColumns:MOB?'repeat(2,1fr)':'repeat(4,1fr)',gap:12,marginBottom:20}}>
        {[
          {l:'Asesores activos', v:asesores.length,    c:DS.primary},
          {l:'Clientes totales', v:totalClientes,       c:'#8b5cf6'},
          {l:'Tasa conversión',  v:`${convEquipo}%`,    c:'#10b981'},
          {l:'Gestión promedio', v:`${gestionEquipo}%`, c:'#f59e0b'},
        ].map((k,i)=>(
          <div key={i} style={{background:'var(--card-bg,#fff)',borderRadius:14,padding:'16px 18px',border:'1px solid #e5e7eb'}}>
            <div style={{fontSize:24,fontWeight:800,color:k.c}}>{k.v}</div>
            <div style={{fontSize:12,fontWeight:700,color:'var(--dark,#0f172a)',marginTop:6}}>{k.l}</div>
          </div>
        ))}
      </div>

      {/* Ordenar */}
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:8,marginBottom:14}}>
        <div style={{fontSize:13,fontWeight:800,color:'var(--dark,#0f172a)'}}>Rendimiento por asesor</div>
        <div style={{display:'flex',gap:6}}>
          {[
            {k:'conversion',l:'Conversión'},
            {k:'gestion',   l:'Gestión'},
            {k:'clientes',  l:'Clientes'},
          ].map(o=>(
            <button key={o.k} onClick={()=>setOrden(o.k)}
              style={{padding:'5px 12px',borderRadius:7,border:'none',fontSize:11,fontWeight:700,cursor:'pointer',
                background:orden===o.k?NAVY:'#fff',color:orden===o.k?'#fff':'#475569',boxShadow:'inset 0 0 0 1px #e5e7eb'}}>
              {o.l}
            </button>
          ))}
        </div>
      </div>

      {/* Cards por asesor */}
      <div style={{display:'grid',gridTemplateColumns:MOB?'1fr':'repeat(auto-fill,minmax(300px,1fr))',gap:14}}>
        {sorted.map((a,i)=>{
          const medal = i===0?'🥇':i===1?'🥈':i===2?'🥉':'';
          return(
            <div key={a.id} style={{background:'#fff',borderRadius:16,border:`1px solid ${i===0?p+'40':'#eaecf0'}`,padding:18,boxShadow:i===0?`0 6px 20px ${p}14`:'none'}}>
              {/* Cabecera del asesor */}
              <div style={{display:'flex',alignItems:'center',gap:11,marginBottom:14}}>
                <div style={{position:'relative'}}>
                  <div style={{width:44,height:44,borderRadius:'50%',background:`${p}15`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:17,fontWeight:800,color:p}}>
                    {(a.name||'?').charAt(0).toUpperCase()}
                  </div>
                  {medal&&<div style={{position:'absolute',top:-6,right:-6,fontSize:16}}>{medal}</div>}
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:14,fontWeight:800,color:'var(--dark,#0f172a)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{a.name}</div>
                  <div style={{fontSize:11,color:'#94a3b8',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{a.email||''}</div>
                </div>
                <span style={{fontSize:10,fontWeight:700,padding:'3px 9px',borderRadius:999,background:a.active?'#dcfce7':'#f1f5f9',color:a.active?'#16a34a':'#94a3b8'}}>{a.active?'Activo':'Inactivo'}</span>
              </div>

              {/* Clientes asignados */}
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',background:'#f8fafc',borderRadius:10,padding:'10px 14px',marginBottom:12}}>
                <div style={{fontSize:12,fontWeight:700,color:'#64748b'}}>Clientes asignados</div>
                <div style={{fontSize:20,fontWeight:800,color:DS.primary}}>{a.total_clientes}</div>
              </div>

              {/* Conversión */}
              <div style={{marginBottom:12}}>
                <div style={{display:'flex',justifyContent:'space-between',marginBottom:5}}>
                  <span style={{fontSize:12,fontWeight:700,color:'#64748b'}}>Conversión</span>
                  <span style={{fontSize:13,fontWeight:800,color:tone(a.conv)}}>{a.conv}%</span>
                </div>
                <div style={{background:'#f1f5f9',borderRadius:999,height:8,overflow:'hidden'}}>
                  <div style={{width:`${a.conv}%`,height:'100%',background:tone(a.conv),borderRadius:999,transition:'width .3s'}}/>
                </div>
                <div style={{fontSize:10,color:'#94a3b8',marginTop:4}}>{a.ganados} ganados · {a.perdidos} perdidos · {a.proceso} en proceso</div>
              </div>

              {/* Gestión */}
              <div>
                <div style={{display:'flex',justifyContent:'space-between',marginBottom:5}}>
                  <span style={{fontSize:12,fontWeight:700,color:'#64748b'}}>Gestión</span>
                  <span style={{fontSize:13,fontWeight:800,color:tone(a.gestion)}}>{a.gestion}%</span>
                </div>
                <div style={{background:'#f1f5f9',borderRadius:999,height:8,overflow:'hidden'}}>
                  <div style={{width:`${a.gestion}%`,height:'100%',background:tone(a.gestion),borderRadius:999,transition:'width .3s'}}/>
                </div>
                <div style={{fontSize:10,color:'#94a3b8',marginTop:4}}>{a.clientesGestion} de {a.total_clientes} clientes gestionados · {a.totalActs} actividades</div>
              </div>
            </div>
          );
        })}
        {sorted.length===0&&(
          <div style={{gridColumn:'1/-1',padding:24,textAlign:'center',color:'#94a3b8',fontSize:12,background:'var(--card-bg,#fff)',borderRadius:16,border:'1px solid #e5e7eb'}}>Sin asesores registrados</div>
        )}
      </div>
    </div>
  );

}

const MSGS_RAPIDOS_SUP = [
  { id:'modalidades',Icon:Star,        label:'Modalidades',    desc:'Las 3 formas de pago',
    texto:`Así funciona cada modalidad:\n⭐ Mega Estrella:  Entrada del 70% para acceder a beneficios preferenciales.\n⭐ Súper Estrella: Empieza hoy y pague una entrada mínima del 35% en el 4to mes.\n⭐ Estrella: Accede a tu vehículo con pagos flexibles.\n\n¿Indíqueme con qué modalidad de pago adquiere su vehículo?` },
  { id:'beneficios', Icon:Gift,        label:'Beneficios',     desc:'Ventajas de adquirir con Busimott',
    texto:`🎁 *Beneficios de adquirir su vehículo con Busimott:*\n\n✅ Vehículo 0 km totalmente a su nombre\n✅ Sin garante y sin necesidad de historial crediticio\n✅ Mensualidades fijas y económicas\n✅ Acompañamiento personalizado durante todo el proceso\n✅ Entrega ágil según la modalidad que elija\n\n¿Le gustaría que le indique con cuál modalidad puede empezar hoy mismo? 🚗` },
  { id:'requisitos', Icon:FileText,    label:'Requisitos',     desc:'Documentos que necesita el cliente',
    texto:`📋 *Requisitos para iniciar:*\n❇️ Cédula de identidad y papeleta de votación\n❇️ Correo electrónico vigente\n❇️ Valor de activación según el plan elegido` },
  { id:'cuenta',     Icon:CreditCard,  label:'Cuenta de pago', desc:'Datos para transferencia bancaria',
    texto:`💳 *Cuenta para registrar su pago:*\n\n👤 Titular: Business Motors Busimott. Cía. Ltda.\n🏦 Banco: Banco del Pichincha\n📋 Tipo: Cuenta Corriente\n🔢 N° de cuenta: 2100247020\n🆔 RUC: 1793140491001\n\n⚠️ Una vez realizado el pago, envíenos el comprobante por este chat.\nAl confirmar el pago procedemos con el envío de su contrato. 🚗` },
  { id:'direccion',  Icon:MapPin,      label:'Dirección',      desc:'Ubicación de las oficinas',
    texto:`📍 *Oficinas Busimott Cía. Ltda.*\n\n🏢 Av. Eloy Alfaro E7-103 y De Los Eucaliptos, Quito\n📞 023 50 0328\n✉️ bussimott.info@gmail.com\n\n¿Qué día y hora le viene mejor para visitarnos? 🤝` },
  { id:'catalogo',   Icon:Image,       label:'Catálogo',       desc:'Link de modelos disponibles',
    texto:`Con gusto 📸 Aquí puede ver todos nuestros modelos disponibles:\n\nhttps://ibb.co/album/PMkJhp\n\nUna vez elija el modelo que le guste, indíqueme el valor del vehículo o el abono mensual que le acomoda y le genero la cotización de inmediato. ¿Cuál le llama la atención?` },
  { id:'valor',      Icon:DollarSign,  label:'Consultar valor', desc:'Preguntar el valor del vehículo',
    texto:`🚗 Para generarle una cotización exacta, cuénteme:\n\n💰 ¿Qué valor de vehículo tiene en mente?\n(Nuestros planes van desde $6.000 hasta $20.000)\n\nO si prefiere, indíqueme la cuota mensual que se ajusta a su presupuesto y yo le calculo el valor ideal para usted. 😊` },
  { id:'servicio',   Icon:Phone,       label:'Servicio al cliente', desc:'Número de servicio al cliente',
    texto:`📞 Para mayor información sobre tu requerimiento, comunícate al siguiente número de servicio al cliente:\n\n0999097014` },
];

function TabConversaciones({ leads, initial }) {
  const p = DS.primary;
  const [sel, setSel] = React.useState(null);
  const [convs, setConvs] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [search, setSearch] = React.useState('');
  const [fromDate, setFromDate] = React.useState('');
  const [toDate, setToDate]     = React.useState('');
  const [msgText, setMsgText]   = React.useState('');
  const [quickOpen, setQuickOpen] = React.useState(false);
  const inputRef = React.useRef(null);
  const endRef = React.useRef(null);

  // Auto-scroll al último mensaje: así no hay que arrastrar la barra para ver lo más reciente.
  React.useEffect(() => { endRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [convs, sel]);

  function handleMsgChange(e) {
    const val = e.target.value;
    setMsgText(val);
    if (val === '*') setQuickOpen(true);
    else if (!val.startsWith('*')) setQuickOpen(false);
  }
  function insertarMensaje(texto) {
    setMsgText(texto);
    setQuickOpen(false);
    setTimeout(() => inputRef.current?.focus(), 50);
  }
  async function enviarMensaje() {
    const txt = msgText.trim();
    if (!txt || !sel) return;
    try {
      let sp = (sel.telefono||'').replace(/\D/g,'');
      if (sp.startsWith('0') && sp.length===10) sp='593'+sp.substring(1);
      else if (sp.length===9) sp='593'+sp;
      await apiFetch('POST','/api/messages/send',{leadId:sel.id,phone:sp,message:txt,companyId:sel.company_id});
      setMsgText(''); setQuickOpen(false); load(sel);
    } catch(e) { alert('Error: '+e.message); }
  }

  async function load(lead) {
    setSel(lead); setLoading(true); setMsgText(''); setQuickOpen(false);
    apiFetch('POST', `/api/supervisor/leads/${lead.id}/contactar`, {}).catch(()=>{});
    try { const d = await apiFetch('GET', `/api/webhook/conversations/${lead.id}`); setConvs(Array.isArray(d)?d:[]); }
    catch(e) { setConvs([]); }
    setLoading(false);
  }

  // Abrir automáticamente la conversación cuando se llega desde "Ver conversación del cliente"
  React.useEffect(() => { if (initial?.id) load(initial); /* eslint-disable-next-line */ }, [initial?.id]);

  const filtered = leads.filter(l => {
    const matchTxt = l.nombre?.toLowerCase().includes(search.toLowerCase()) || l.telefono?.includes(search);
    if (!matchTxt) return false;
    const fecha = (l.created_at || l.fecha || '').slice(0,10);
    if (fromDate && fecha < fromDate) return false;
    if (toDate   && fecha > toDate)   return false;
    return true;
  });
  const NIVEL = { caliente:{c:'#10b981',bg:'#f0fdf9',l:'Caliente'}, tibio:{c:'#f59e0b',bg:'#fefce8',l:'Tibio'}, frio:{c:'#ef4444',bg:'#fef2f2',l:'Frio'} };
  // Paginado: con miles de leads, renderizarlos todos de una vez es lo que traba el clic en la pestaña.
  const { paged: pagedLeads, ...pgLeads } = usePaged(filtered, 30);

  return (
    <div style={{display:MOB?'block':'grid',gridTemplateColumns:'300px 1fr',gap:16,height:MOB?'auto':'75vh'}}>
      {(!MOB || !sel) && <div style={{background:'var(--card-bg,#fff)',borderRadius:16,border:'1px solid #e5e7eb',display:'flex',flexDirection:'column',overflow:'hidden',height:MOB?'70vh':'auto'}}>
        <div style={{padding:'12px 14px',borderBottom:'1px solid #eaecf0'}}>
          <div style={{fontSize:11,color:p,fontWeight:700,textTransform:'uppercase',marginBottom:6}}>Conversaciones del bot</div>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Buscar cliente..." style={{width:'100%',padding:'7px 11px',borderRadius:8,border:'1px solid #e2e8f0',fontSize:12,outline:'none',boxSizing:'border-box',marginBottom:6}}/>
          <div style={{display:'flex',gap:6,alignItems:'center'}}>
            <input type="date" value={fromDate} max={toDate||undefined} onChange={e=>setFromDate(e.target.value)}
              style={{flex:1,padding:'6px 8px',borderRadius:8,border:'1px solid #e2e8f0',fontSize:11,fontWeight:700,color:'#475569',outline:'none',cursor:'pointer'}}/>
            <span style={{fontSize:10,color:'#94a3b8',fontWeight:700}}>a</span>
            <input type="date" value={toDate} min={fromDate||undefined} onChange={e=>setToDate(e.target.value)}
              style={{flex:1,padding:'6px 8px',borderRadius:8,border:'1px solid #e2e8f0',fontSize:11,fontWeight:700,color:'#475569',outline:'none',cursor:'pointer'}}/>
            {(fromDate||toDate) && <button onClick={()=>{setFromDate('');setToDate('');}} title="Limpiar fechas" style={{background:'none',border:'none',cursor:'pointer',color:'#94a3b8',padding:2}}><X size={13}/></button>}
          </div>
        </div>
        <div style={{flex:1,overflowY:'auto'}}>
          {pagedLeads.map(lead=>{
            const nv=NIVEL[lead.nivel]||NIVEL.frio;
            const isSel=sel?.id===lead.id;
            const contactado=!!lead.metadata?.asesor_contacto;
            return(<div key={lead.id} onClick={()=>load(lead)} style={{padding:'10px 14px',borderBottom:'1px solid #f1f5f9',cursor:'pointer',background:isSel?`${p}08`:'transparent',borderLeft:isSel?`3px solid ${p}`:'3px solid transparent'}}>
              <div style={{display:'flex',justifyContent:'space-between',marginBottom:3,gap:6}}>
                <span style={{fontSize:12,fontWeight:700,color:'var(--dark,#0f172a)'}}>{lead.nombre}</span>
                <div style={{display:'flex',gap:4,flexShrink:0}}>
                  {contactado
                    ? <span style={{fontSize:9,fontWeight:700,color:'#059669',background:'#f0fdf4',padding:'1px 7px',borderRadius:999,whiteSpace:'nowrap'}}>✓ Contactado</span>
                    : <span style={{fontSize:9,fontWeight:700,color:'#94a3b8',background:'#f1f5f9',padding:'1px 7px',borderRadius:999,whiteSpace:'nowrap'}}>Sin contactar</span>}
                  <span style={{fontSize:10,fontWeight:700,color:nv.c,background:nv.bg,padding:'1px 7px',borderRadius:999}}>{nv.l}</span>
                </div>
              </div>
              <div style={{fontSize:11,color:'#64748b'}}>{lead.telefono}</div>
            </div>);
          })}
          {filtered.length===0&&<div style={{padding:20,textAlign:'center',color:'#94a3b8',fontSize:12}}>Sin leads</div>}
          <Pagination {...pgLeads} primary={p} label="leads" />
        </div>
      </div>}
      {(!MOB || sel) && <div style={{background:'var(--card-bg,#fff)',borderRadius:16,border:'1px solid #e5e7eb',display:'flex',flexDirection:'column',overflow:'hidden',height:MOB?'70vh':'auto'}}>
        {MOB && sel && <button onClick={()=>setSel(null)} style={{margin:'10px 14px 0',padding:'8px 14px',background:'none',border:'1px solid #e2e8f0',borderRadius:8,fontSize:13,cursor:'pointer',textAlign:'left',color:DS.primary,fontWeight:600}}>← Volver</button>}
        {!sel?(<div style={{flex:1,display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',gap:8}}>
          <MessageCircle size={36} color="#e2e8f0"/>
          <div style={{fontSize:13,color:'#94a3b8',fontWeight:600}}>Selecciona un lead para ver la conversacion</div>
        </div>):(
          <>
            <div style={{padding:'12px 16px',borderBottom:'1px solid #eaecf0',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <div>
                <div style={{fontSize:14,fontWeight:700,color:'var(--dark,#0f172a)'}}>{sel.nombre}</div>
                <div style={{fontSize:11,color:'#64748b'}}>{sel.telefono} · Score: {sel.score}/100</div>
              </div>
              <button onClick={()=>{apiFetch('POST',`/api/supervisor/leads/${sel.id}/contactar`,{}).catch(()=>{});window.open(`https://wa.me/${(()=>{let n=(sel.telefono||'').replace(/\D/g,'');if(n.startsWith('0')&&n.length===10)n='593'+n.substring(1);else if(n.length===9)n='593'+n;return n;})()}?text=Hola%20${encodeURIComponent(sel.nombre||'')}%2C%20soy%20del%20equipo%20BUSIMOTT`,'_blank');}}
                style={{padding:'7px 14px',borderRadius:8,border:'none',background:'#f0fdf9',color:'#059669',fontWeight:700,fontSize:12,cursor:'pointer',display:'flex',alignItems:'center',gap:5}}>
                <MessageCircle size={12}/> Abrir WhatsApp
              </button>
            </div>
            <div style={{flex:1,overflowY:'auto',padding:'14px 16px',display:'flex',flexDirection:'column',gap:8,background:'#f8fafc'}}>
              {loading&&<div style={{textAlign:'center',color:'#94a3b8',fontSize:12,padding:20}}>Cargando...</div>}
              {!loading&&convs.length===0&&<div style={{textAlign:'center',color:'#94a3b8',fontSize:12,padding:20}}>Sin mensajes aun</div>}
              {convs.map((m,i)=>{
                const isBot=m.direction==='outbound';
                return(<div key={i} style={{display:'flex',justifyContent:isBot?'flex-start':'flex-end'}}>
                  <div style={{maxWidth:'70%'}}>
                    <div style={{fontSize:10,color:'#94a3b8',marginBottom:2,textAlign:isBot?'left':'right'}}>{isBot?'Claudia (Bot)':sel.nombre}</div>
                    <div style={{padding:'9px 13px',borderRadius:isBot?'4px 12px 12px 12px':'12px 4px 12px 12px',background:isBot?'#fff':p,color:isBot?'var(--dark,#0f172a)':'#fff',fontSize:12,lineHeight:1.5,border:isBot?'1px solid #e2e8f0':'none'}}>
                      {m.message_text&&m.message_text.startsWith('[IMG:')?(()=>{const u=m.message_text.match(/\[IMG:(.*?)\]/);return u?(<><img src={(process.env.REACT_APP_API_URL||'')+u[1]} alt="Imagen" style={{maxWidth:'100%',borderRadius:8,marginBottom:4,cursor:'pointer'}} onClick={()=>window.open((process.env.REACT_APP_API_URL||'')+u[1],'_blank')}/><div style={{fontSize:11}}>{m.message_text.replace(/\[IMG:.*?\]\s*/,'')}</div></>):m.message_text;})():m.message_text}
                    </div>
                    <div style={{fontSize:10,color:'#cbd5e1',marginTop:2,textAlign:isBot?'left':'right'}}>
                      {m.created_at?new Date(m.created_at).toLocaleString('es-EC',{month:'short',day:'numeric',hour:'2-digit',minute:'2-digit'}):''}
                    </div>
                  </div>
                </div>);
              })}
              <div ref={endRef}/>
            </div>
            {(()=>{
              const lastIn=convs.filter(m=>m.direction==='inbound').sort((a,b)=>new Date(b.created_at)-new Date(a.created_at))[0];
              const horas=lastIn?(Date.now()-new Date(lastIn.created_at).getTime())/(1000*60*60):999;
              if(horas>24) return(
                <div style={{padding:'12px 16px',borderTop:'1px solid #eaecf0',background:'#fef3c7',display:'flex',alignItems:'center',gap:10}}>
                  <Clock size={16} color='#d97706'/>
                  <div style={{flex:1}}>
                    <div style={{fontSize:12,fontWeight:700,color:'#92400e'}}>Ventana de 24 horas cerrada</div>
                    <div style={{fontSize:11,color:'#b45309'}}>Espera a que el cliente te escriba de nuevo para poder responder.</div>
                  </div>
                  <button onClick={()=>{marcarContactado(sel.telefono);window.open(`https://wa.me/${toWA(sel.telefono)}`,'_blank');}} style={{padding:'7px 12px',borderRadius:8,border:'none',background:'#25d366',color:'#fff',fontWeight:700,fontSize:11,cursor:'pointer',whiteSpace:'nowrap',flexShrink:0}}>
                    <MessageCircle size={11}/> Abrir WA
                  </button>
                </div>
              );
              return(
                <div style={{padding:'10px 16px',borderTop:'1px solid #eaecf0',background:'#fff',position:'relative'}}>

                  {/* ── Panel mensajes rápidos ── */}
                  {quickOpen && (
                    <div style={{position:'absolute',bottom:'100%',left:16,right:16,marginBottom:6,background:'#fff',border:'1.5px solid #e2e8f0',borderRadius:14,boxShadow:'0 8px 32px rgba(0,0,0,0.13)',zIndex:100,overflow:'hidden'}}>
                      <div style={{padding:'10px 14px 8px',borderBottom:'1px solid #f1f5f9',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                        <div style={{display:'flex',alignItems:'center',gap:6}}>
                          <Zap size={14} color={p}/>
                          <span style={{fontSize:12,fontWeight:700,color:'var(--dark,#0f172a)'}}>Mensajes Rápidos</span>
                        </div>
                        <button onClick={()=>{setQuickOpen(false);setMsgText('');}} style={{background:'none',border:'none',cursor:'pointer',color:'#94a3b8',padding:2}}><X size={15}/></button>
                      </div>
                      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:0}}>
                        {MSGS_RAPIDOS_SUP.map((item,i)=>(
                          <button key={item.id} onClick={()=>insertarMensaje(item.texto)}
                            style={{padding:'12px 10px',background:'transparent',border:'none',borderRight:i%3!==2?'1px solid #f1f5f9':'none',borderBottom:'1px solid #f1f5f9',cursor:'pointer',textAlign:'left',transition:'background .12s'}}
                            onMouseEnter={e=>e.currentTarget.style.background='#f8fafc'}
                            onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                            <div style={{marginBottom:6,display:'flex',alignItems:'center'}}>
                              <div style={{width:32,height:32,borderRadius:8,background:`${p}14`,display:'flex',alignItems:'center',justifyContent:'center'}}>
                                <item.Icon size={16} color={p}/>
                              </div>
                            </div>
                            <div style={{fontSize:12,fontWeight:700,color:'var(--dark,#0f172a)',marginBottom:2}}>{item.label}</div>
                            <div style={{fontSize:10,color:'#94a3b8',lineHeight:1.3}}>{item.desc}</div>
                          </button>
                        ))}
                      </div>
                      <div style={{padding:'6px 14px',fontSize:10,color:'#cbd5e1',textAlign:'center',borderTop:'1px solid #f1f5f9'}}>
                        Selecciona una opción · ESC para cerrar
                      </div>
                    </div>
                  )}

                  <div style={{display:'flex',gap:8,alignItems:'flex-end'}}>
                    <div style={{flex:1,position:'relative'}}>
                      <textarea ref={inputRef} value={msgText} onChange={handleMsgChange} rows={2} placeholder="Escribe un mensaje… o escribe * para mensajes rápidos"
                        style={{width:'100%',padding:'9px 12px',borderRadius:9,border:quickOpen?`1.5px solid ${p}`:'1px solid #e2e8f0',fontSize:12,resize:'none',outline:'none',fontFamily:'inherit',boxSizing:'border-box'}}
                        onKeyDown={e=>{
                          if(e.key==='Escape'){setQuickOpen(false);setMsgText('');}
                          if(e.key==='Enter'&&!e.shiftKey&&!quickOpen){e.preventDefault();enviarMensaje();}
                        }}/>
                      {!quickOpen && (
                        <button onClick={()=>{setMsgText('*');setQuickOpen(true);setTimeout(()=>inputRef.current?.focus(),50);}}
                          title="Mensajes rápidos (*)"
                          style={{position:'absolute',right:8,bottom:8,background:'none',border:'1px solid #e2e8f0',borderRadius:6,padding:'4px 6px',cursor:'pointer',display:'flex',alignItems:'center'}}>
                          <Zap size={13} color='#94a3b8'/>
                        </button>
                      )}
                    </div>
                    <div style={{display:'flex',flexDirection:'column',gap:5}}>
                      <button onClick={enviarMensaje} style={{padding:'9px 14px',borderRadius:8,border:'none',background:'#25d366',color:'#fff',fontWeight:700,fontSize:12,cursor:'pointer',display:'flex',alignItems:'center',gap:4}}>
                        <MessageCircle size={12}/> Enviar
                      </button>
                      <button onClick={()=>{marcarContactado(sel.telefono);window.open(`https://wa.me/${toWA(sel.telefono)}?text=Hola`,'_blank');}} style={{padding:'7px 14px',borderRadius:8,border:'none',background:'#f0fdf9',color:'#059669',fontWeight:700,fontSize:11,cursor:'pointer'}}>
                        Abrir WA
                      </button>
                    </div>
                  </div>
                </div>
              );
            })()}
          </>
        )}
      </div>}
    </div>
  );
}

/* Modal de detalle de un cliente propio del supervisor + reasignación de asesor */
function MiClienteDetalle({ client, asesores, onClose, onEditar, onReasignado, onVerConversacion }) {
  const p = DS.primary;
  const [nuevoAsesor, setNuevoAsesor] = React.useState('');
  const [reasignando, setReasignando] = React.useState(false);
  const heatCfg = {caliente:{c:'#ef4444',bg:'#fff5f5',l:'🔥 Caliente'},tibio:{c:'#f59e0b',bg:'#fffbeb',l:'🌡️ Tibio'},frio:{c:'#4f6ef7',bg:'#f0f1ff',l:'❄️ Frío'}}[client.heat||'tibio']||{c:'#94a3b8',bg:'#f1f5f9',l:'—'};
  const cedula = client.cedula || client.metadata?.cedula || '—';

  async function reasignar() {
    if (!nuevoAsesor) return;
    const a = withSup(asesores).find(x => String(x.id) === String(nuevoAsesor));
    setReasignando(true);
    try {
      await apiFetch('PUT', `/api/clients/${client.id}`, { assignedAdvisorId: nuevoAsesor });
      onReasignado(client.id, a?.name || '');
      onClose();
    } catch(e) { alert('Error al reasignar: ' + e.message); }
    setReasignando(false);
  }

  const campos = [
    { label:'TELÉFONO',     value: client.phone || '—' },
    { label:'EMAIL',        value: client.email || '—' },
    { label:'CÉDULA / RUC', value: cedula },
    { label:'TEMPERATURA',  value: heatCfg.l },
  ];

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(15,23,42,0.5)',backdropFilter:'blur(4px)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}
      onClick={e=>{if(e.target===e.currentTarget)onClose();}}>
      <div style={{background:'#fff',borderRadius:20,padding:28,width:480,maxHeight:'88vh',overflowY:'auto',boxShadow:'0 24px 64px rgba(0,0,0,0.3)'}}>
        {/* Header */}
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:18}}>
          <div>
            <h2 style={{margin:'0 0 6px',fontSize:20,fontWeight:800,color:'var(--dark,#0f172a)'}}>{client.name}</h2>
            <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
              <span style={{background:heatCfg.bg,color:heatCfg.c,padding:'3px 9px',borderRadius:6,fontSize:11,fontWeight:700}}>{heatCfg.l}</span>
              {client.result==='won'  && <span style={{background:'#d1fae5',color:'#10b981',padding:'3px 9px',borderRadius:6,fontSize:11,fontWeight:700}}>✓ Ganado</span>}
              {client.result==='lost' && <span style={{background:'#fee2e2',color:'#ef4444',padding:'3px 9px',borderRadius:6,fontSize:11,fontWeight:700}}>✗ Perdido</span>}
              {!client.result         && <span style={{background:'#fffbeb',color:'#f59e0b',padding:'3px 9px',borderRadius:6,fontSize:11,fontWeight:700}}>● En proceso</span>}
            </div>
          </div>
          <div style={{display:'flex',gap:8}}>
            <button onClick={()=>{onEditar(client);onClose();}} style={{border:'none',background:'#f1f5f9',borderRadius:8,padding:'7px 12px',cursor:'pointer',display:'flex',alignItems:'center',gap:5,color:'#475569',fontSize:12,fontWeight:700}}>
              <Edit2 size={13}/> Editar
            </button>
            <button onClick={onClose} style={{border:'none',background:'rgba(var(--primary-rgb),0.10)',borderRadius:8,padding:'8px 10px',cursor:'pointer'}}><X size={16} color="#64748b"/></button>
          </div>
        </div>

        {/* Datos */}
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:16}}>
          {campos.map((f,i)=>(
            <div key={i} style={{background:'#f5f7fb',borderRadius:10,padding:'12px 14px'}}>
              <div style={{fontSize:10,color:'#9aa5be',fontWeight:700,marginBottom:4}}>{f.label}</div>
              <div style={{fontSize:13,fontWeight:600,color:'#4a5568',wordBreak:'break-word'}}>{f.value}</div>
            </div>
          ))}
        </div>

        {client.notes && (
          <div style={{background:'#fef3c7',borderRadius:10,padding:'12px 14px',marginBottom:12,fontSize:13,color:'#92400e'}}>
            <b>Notas:</b> {client.notes}
          </div>
        )}
        {client.result==='lost' && (client.lossReason || client.metadata?.lossReason) && (
          <div style={{background:'#fef2f2',borderRadius:10,padding:'12px 14px',border:'1px solid #fecaca',marginBottom:12}}>
            <div style={{fontSize:11,fontWeight:700,color:'#dc2626',marginBottom:4,textTransform:'uppercase'}}>Concepto (razón de pérdida)</div>
            <div style={{fontSize:13,color:'#7f1d1d',lineHeight:1.5}}>{client.lossReason || client.metadata?.lossReason}</div>
          </div>
        )}

        {/* Reasignar asesor */}
        <div style={{background:'#f0f1ff',borderRadius:12,padding:'14px 16px',border:`1px solid ${p}25`,marginBottom:14}}>
          <div style={{fontSize:11,fontWeight:700,color:p,marginBottom:8,textTransform:'uppercase',letterSpacing:0.5,display:'flex',alignItems:'center',gap:6}}>
            <UserCheck size={13}/> Cambiar de asesor
          </div>
          <div style={{display:'flex',gap:8}}>
            <select value={nuevoAsesor} onChange={e=>setNuevoAsesor(e.target.value)}
              style={{flex:1,padding:'9px 12px',border:'1px solid #e5e7eb',borderRadius:10,background:'#fff',fontSize:13,outline:'none',background:'#fff',cursor:'pointer'}}>
              <option value="">— Selecciona un asesor —</option>
              {withSup(asesores).map(a=><option key={a.id} value={a.id}>{a.name}</option>)}
            </select>
            <button onClick={reasignar} disabled={!nuevoAsesor||reasignando}
              style={{padding:'9px 16px',borderRadius:9,border:'none',background:!nuevoAsesor||reasignando?'#a5b4fc':p,color:'#fff',fontWeight:700,fontSize:13,cursor:!nuevoAsesor||reasignando?'default':'pointer',whiteSpace:'nowrap'}}>
              {reasignando?'Reasignando...':'Reasignar'}
            </button>
          </div>
          <div style={{fontSize:11,color:'#64748b',marginTop:8}}>Al reasignar, el cliente pasará a la lista del asesor seleccionado y dejará de aparecer en "Mis Clientes".</div>
        </div>

        {/* Acciones de contacto */}
        <div style={{display:'flex',gap:10}}>
          {onVerConversacion && (
            <button onClick={()=>{onVerConversacion(client);onClose();}}
              style={{flex:1,padding:'10px 0',borderRadius:10,background:'#eff6ff',color:'#2563eb',fontWeight:700,fontSize:13,display:'flex',alignItems:'center',justifyContent:'center',gap:6,border:'none',cursor:'pointer'}}>
              <MessageCircle size={14}/> Ver conversación
            </button>
          )}
          <a href={`https://wa.me/${toWA(client.phone)}`} target="_blank" rel="noreferrer" onClick={()=>marcarContactado(client.phone)}
            style={{flex:1,padding:'10px 0',borderRadius:10,background:'#f0fdf4',color:'#16a34a',fontWeight:700,fontSize:13,display:'flex',alignItems:'center',justifyContent:'center',gap:6,textDecoration:'none'}}>
            <MessageCircle size={14}/> WhatsApp
          </a>
          <a href={`tel:${client.phone}`}
            style={{flex:1,padding:'10px 0',borderRadius:10,background:'rgba(var(--primary-rgb),0.10)',color:p,fontWeight:700,fontSize:13,display:'flex',alignItems:'center',justifyContent:'center',gap:6,textDecoration:'none'}}>
            <Phone size={14}/> Llamar
          </a>
        </div>
      </div>
    </div>
  );
}

function TabMisClientes({ user, onVerConversacion }) {
  const p = DS.primary;
  const [clients, setClients] = useState([]);
  const [leads,   setLeads]   = useState([]);
  const [asesores,setAsesores]= useState([]);
  const [detail,  setDetail]  = useState(null);
  const [loading, setLoading] = useState(true);
  const [search,  setSearch]  = useState('');
  const [tab,     setTab]     = useState('clientes');
  const [sendModal,   setSendModal]   = useState(null);
  const [editModal,   setEditModal]   = useState(null); // null | 'new' | client obj
  const [lossModal,   setLossModal]   = useState(null);
  const [winModal,    setWinModal]    = useState(null);
  const [msg, setMsg] = useState('');
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ name:'', phone:'', email:'', cedula:'', notes:'', heat:'tibio' });

  function openNew()  { setForm({ name:'', phone:'', email:'', cedula:'', notes:'', heat:'tibio' }); setEditModal('new'); }
  function openEdit(c){ setForm({ name:c.name||'', phone:c.phone||'', email:c.email||'', cedula:c.cedula||c.metadata?.cedula||'', notes:c.notes||'', heat:c.metadata?.heat||c.heat||'tibio' }); setEditModal(c); }

  async function guardar() {
    if (!form.name || !form.phone) return alert('Nombre y teléfono son obligatorios');
    setSaving(true);
    try {
      if (editModal === 'new') {
        const r = await apiFetch('POST', '/api/supervisor/mis-clientes', form);
        setClients(p => [r, ...p]);
      } else {
        await apiFetch('PUT', `/api/supervisor/mis-clientes/${editModal.id}`, form);
        setClients(p => p.map(c => c.id === editModal.id ? { ...c, ...form } : c));
      }
      setEditModal(null);
    } catch(e) { alert('Error: ' + e.message); }
    setSaving(false);
  }

  function eliminar(c) {
    askConfirm(`¿Eliminar a ${c.name}? Esta acción no se puede deshacer.`, async () => {
      try {
        await apiFetch('DELETE', `/api/supervisor/mis-clientes/${c.id}`);
        setClients(p => p.filter(x => x.id !== c.id));
      } catch(e) { alert('Error: ' + e.message); }
    });
  }

  async function marcarPerdido(c, concepto) {
    try {
      await apiFetch('PUT', `/api/supervisor/mis-clientes/${c.id}`, { result:'lost', lossReason: concepto });
      setClients(p => p.map(x => x.id===c.id ? { ...x, result:'lost', lossReason: concepto } : x));
    } catch(e) { alert('Error: ' + e.message); }
    setLossModal(null);
  }

  async function marcarGanado(c, concepto) {
    try {
      await apiFetch('PUT', `/api/supervisor/mis-clientes/${c.id}`, { result:'won', lossReason: concepto });
      setClients(p => p.map(x => x.id===c.id ? { ...x, result:'won', lossReason: concepto } : x));
    } catch(e) { alert('Error: ' + e.message); }
    setWinModal(null);
  }

  async function reabrir(c) {
    try {
      await apiFetch('PUT', `/api/supervisor/mis-clientes/${c.id}`, { result:null, lossReason:'' });
      setClients(p => p.map(x => x.id===c.id ? { ...x, result:null, lossReason:'' } : x));
    } catch(e) { alert('Error: ' + e.message); }
  }

  useEffect(() => {
    setLoading(true);
    Promise.all([
      apiFetch('GET', '/api/supervisor/mis-clientes').catch(()=>[]),
      apiFetch('GET', '/api/supervisor/mis-leads').catch(()=>[]),
      apiFetch('GET', '/api/supervisor/asesores').catch(()=>[]),
    ]).then(([c, l, a]) => {
      setClients(Array.isArray(c) ? c.map(x=>({...x,result:x.result||x.metadata?.result||null,heat:x.metadata?.heat||x.heat||'tibio',lossReason:x.lossReason||x.metadata?.lossReason||'',cedula:x.cedula||x.metadata?.cedula||'',producto:x.producto||x.metadata?.producto||''})) : []);
      setLeads(Array.isArray(l) ? l : []);
      setAsesores(Array.isArray(a) ? a : []);
      setLoading(false);
    });
  }, []);

  async function enviarMsg(cliente) {
    if (!msg.trim()) return;
    try {
      let phone = (cliente.phone||'').replace(/\D/g,'');
      if (phone.startsWith('0') && phone.length===10) phone='593'+phone.substring(1);
      else if (phone.length===9) phone='593'+phone;
      await apiFetch('POST', '/api/messages/send', {
        phone, message: msg, companyId: cliente.company_id
      });
      setSendModal(null); setMsg('');
      alert('✅ Mensaje enviado a ' + cliente.name);
    } catch(e) { alert('❌ Error: ' + e.message); }
  }

  const CLS = {
    caliente:{ c:'#ef4444', b:'#fff5f5', l:'Caliente' },
    tibio:   { c:'#f59e0b', b:'#fffbeb', l:'Tibio'    },
    frio:    { c:'#4f6ef7', b:'#f0f1ff', l:'Frío'     },
    won:     { c:'#10b981', b:'#f0fdf9', l:'Ganado'   },
    lost:    { c:'#ef4444', b:'#fef2f2', l:'Perdido'  },
  };

  const filteredC = clients.filter(c => c.name?.toLowerCase().includes(search.toLowerCase()) || c.phone?.includes(search));
  const filteredL = leads.filter(l => l.nombre?.toLowerCase().includes(search.toLowerCase()) || l.telefono?.includes(search));
  const pgC = usePaged(filteredC, 12);
  const pgL = usePaged(filteredL, 12);

  return (
    <div>
      {/* Send message modal */}
      {sendModal && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}>
          <div style={{background:'#fff',borderRadius:16,padding:24,width:360,boxShadow:'0 20px 60px rgba(0,0,0,0.2)'}}>
            <div style={{fontSize:14,fontWeight:800,marginBottom:4}}>Enviar mensaje</div>
            <div style={{fontSize:12,color:'#94a3b8',marginBottom:14}}>{sendModal.name} — {sendModal.phone}</div>
            <textarea value={msg} onChange={e=>setMsg(e.target.value)} rows={3}
              placeholder="Escribe tu mensaje..."
              style={{width:'100%',padding:'10px 12px',borderRadius:9,border:'1px solid #e2e8f0',fontSize:13,resize:'none',outline:'none',fontFamily:'inherit',marginBottom:10,boxSizing:'border-box'}}/>
            <div style={{display:'flex',gap:8}}>
              <button onClick={()=>{setSendModal(null);setMsg('');}} style={{flex:1,padding:'9px',borderRadius:8,border:'none',background:'#f1f5f9',cursor:'pointer',fontSize:12,fontWeight:700}}>Cancelar</button>
              <button onClick={()=>enviarMsg(sendModal)} style={{flex:1,padding:'9px',borderRadius:8,border:'none',background:'#25d366',color:'#fff',cursor:'pointer',fontSize:12,fontWeight:700,display:'flex',alignItems:'center',justifyContent:'center',gap:5}}>
                <MessageCircle size={13}/> Enviar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
        <div>
          <div style={{fontSize:11,color:p,fontWeight:700,letterSpacing:1.5,textTransform:'uppercase',marginBottom:2}}>Mi gestión</div>
          <h2 style={{margin:0,fontSize:20,fontWeight:800,color:'var(--dark,#0f172a)'}}>Mis Clientes y Leads</h2>
        </div>
        <div style={{display:'flex',gap:8,alignItems:'center'}}>
          <button onClick={openNew}
            style={{display:'flex',alignItems:'center',gap:6,padding:'9px 16px',borderRadius:9,border:'none',background:p,color:'#fff',fontWeight:700,fontSize:12,cursor:'pointer'}}>
            <Plus size={13}/> Nuevo cliente
          </button>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Buscar..."
            style={{padding:'8px 14px',borderRadius:9,border:'1px solid #e2e8f0',fontSize:12,outline:'none',width:180}}/>
        </div>
      </div>

      {/* Tabs */}
      <div style={{display:'flex',gap:6,marginBottom:16,overflowX:'auto',flexWrap:'nowrap',WebkitOverflowScrolling:'touch',paddingBottom:4}}>
        {[
          {k:'clientes', l:`Mis Clientes (${clients.length})`},
          {k:'leads',    l:`Mis Leads (${leads.length})`},
          {k:'conversaciones', l:'Mis Conversaciones'},
        ].map(t=>(
          <button key={t.k} onClick={()=>setTab(t.k)}
            style={{padding:'8px 16px',borderRadius:8,border:'none',fontSize:12,fontWeight:700,cursor:'pointer',
              background:tab===t.k?NAVY:'#fff',color:tab===t.k?'#fff':'#475569',boxShadow:'inset 0 0 0 1px #e5e7eb'}}>
            {t.l}
          </button>
        ))}
      </div>

      {/* Modal editar/crear cliente */}
      {editModal && (
        <div style={{position:'fixed',inset:0,background:'rgba(15,23,42,0.5)',backdropFilter:'blur(4px)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}>
          <div style={{background:'#fff',borderRadius:20,padding:28,width:460,boxShadow:'0 24px 60px rgba(0,0,0,0.2)'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20}}>
              <h3 style={{margin:0,fontSize:17,fontWeight:800,color:'var(--dark,#0f172a)'}}>{editModal==='new'?'Nuevo cliente':'Editar cliente'}</h3>
              <button onClick={()=>setEditModal(null)} style={{border:'none',background:'#f1f5f9',borderRadius:8,padding:7,cursor:'pointer',display:'flex'}}><X size={14} color="#64748b"/></button>
            </div>
            <div style={{display:'flex',flexDirection:'column',gap:10,marginBottom:16}}>
              {[{l:'Nombre *',k:'name',t:'text'},{l:'Teléfono *',k:'phone',t:'tel'},{l:'Email',k:'email',t:'email'},{l:'Cédula / RUC',k:'cedula',t:'text'}].map(f=>(
                <div key={f.k}>
                  <div style={{fontSize:10,color:'#94a3b8',fontWeight:700,marginBottom:4}}>{f.l.toUpperCase()}</div>
                  <input type={f.t} value={form[f.k]} onChange={e=>setForm(x=>({...x,[f.k]:e.target.value}))}
                    style={{width:'100%',padding:'9px 12px',border:'1px solid #e2e8f0',borderRadius:9,fontSize:13,outline:'none',boxSizing:'border-box'}}/>
                </div>
              ))}
              <div>
                <div style={{fontSize:10,color:'#94a3b8',fontWeight:700,marginBottom:4}}>TEMPERATURA</div>
                <div style={{display:'flex',gap:8}}>
                  {[{v:'caliente',l:'🔥 Caliente',c:'#ef4444'},{v:'tibio',l:'🌡️ Tibio',c:'#f59e0b'},{v:'frio',l:'❄️ Frío',c:DS.primary}].map(h=>(
                    <button key={h.v} onClick={()=>setForm(x=>({...x,heat:h.v}))}
                      style={{flex:1,padding:'8px',borderRadius:8,border:`2px solid ${form.heat===h.v?h.c:'#e2e8f0'}`,background:form.heat===h.v?`${h.c}15`:'#fff',color:form.heat===h.v?h.c:'#94a3b8',fontWeight:700,fontSize:11,cursor:'pointer'}}>
                      {h.l}
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <div style={{fontSize:10,color:'#94a3b8',fontWeight:700,marginBottom:4}}>NOTAS</div>
                <textarea value={form.notes} onChange={e=>setForm(x=>({...x,notes:e.target.value}))} rows={3}
                  style={{width:'100%',padding:'9px 12px',border:'1px solid #e2e8f0',borderRadius:9,fontSize:13,outline:'none',resize:'none',boxSizing:'border-box'}}/>
              </div>
            </div>
            <div style={{display:'flex',gap:10}}>
              <button onClick={()=>setEditModal(null)} style={{flex:1,padding:'10px',borderRadius:10,border:'1px solid #e2e8f0',background:'#f8fafc',color:'#64748b',fontWeight:700,cursor:'pointer',fontSize:13}}>Cancelar</button>
              <button onClick={guardar} disabled={saving} style={{flex:2,padding:'10px',borderRadius:10,border:'none',background:p,color:'#fff',fontWeight:700,cursor:'pointer',fontSize:13}}>
                {saving?'Guardando...':'✓ Guardar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal concepto de pérdida */}
      {lossModal && (
        <div style={{position:'fixed',inset:0,background:'rgba(15,23,42,0.5)',backdropFilter:'blur(4px)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}>
          <div style={{background:'#fff',borderRadius:20,padding:28,width:420,boxShadow:'0 24px 60px rgba(0,0,0,0.2)'}}>
            <h3 style={{margin:'0 0 16px',fontSize:16,fontWeight:800,color:'var(--dark,#0f172a)'}}>Concepto de pérdida</h3>
            <div style={{fontSize:12,color:'#64748b',marginBottom:12}}>{lossModal.name}</div>
            <textarea id="loss-concepto" rows={4} placeholder="Describe por qué se perdió este cliente..."
              style={{width:'100%',padding:'10px 12px',border:'1px solid #e2e8f0',borderRadius:9,fontSize:13,outline:'none',resize:'none',boxSizing:'border-box',marginBottom:14}}/>
            <div style={{display:'flex',gap:10}}>
              <button onClick={()=>setLossModal(null)} style={{flex:1,padding:'10px',borderRadius:10,border:'1px solid #e2e8f0',background:'#f8fafc',color:'#64748b',fontWeight:700,cursor:'pointer'}}>Cancelar</button>
              <button onClick={()=>{const v=document.getElementById('loss-concepto').value.trim();if(!v)return;marcarPerdido(lossModal,v);}}
                style={{flex:2,padding:'10px',borderRadius:10,border:'none',background:'#ef4444',color:'#fff',fontWeight:700,cursor:'pointer'}}>Confirmar pérdida</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal confirmación de venta ganada */}
      {winModal && (
        <div style={{position:'fixed',inset:0,background:'rgba(15,23,42,0.5)',backdropFilter:'blur(4px)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}>
          <div style={{background:'#fff',borderRadius:20,padding:28,width:420,boxShadow:'0 24px 60px rgba(0,0,0,0.2)'}}>
            <h3 style={{margin:'0 0 16px',fontSize:16,fontWeight:800,color:'#10b981'}}>✓ Marcar como Ganado</h3>
            <div style={{fontSize:12,color:'#64748b',marginBottom:12}}>{winModal.name}</div>
            <textarea id="win-concepto" rows={3} placeholder="Detalle de la venta (opcional)..."
              style={{width:'100%',padding:'10px 12px',border:'1px solid #e2e8f0',borderRadius:9,fontSize:13,outline:'none',resize:'none',boxSizing:'border-box',marginBottom:14}}/>
            <div style={{display:'flex',gap:10}}>
              <button onClick={()=>setWinModal(null)} style={{flex:1,padding:'10px',borderRadius:10,border:'1px solid #e2e8f0',background:'#f8fafc',color:'#64748b',fontWeight:700,cursor:'pointer'}}>Cancelar</button>
              <button onClick={()=>{const v=document.getElementById('win-concepto').value.trim();marcarGanado(winModal,v||'Venta cerrada');}}
                style={{flex:2,padding:'10px',borderRadius:10,border:'none',background:'#10b981',color:'#fff',fontWeight:700,cursor:'pointer'}}>✓ Confirmar venta</button>
            </div>
          </div>
        </div>
      )}

      {loading ? (
        <div style={{textAlign:'center',padding:40,color:'#94a3b8'}}>Cargando...</div>
      ) : tab==='clientes' ? (
        <div style={{background:'var(--card-bg,#fff)',borderRadius:16,border:'1px solid #e5e7eb',overflowX:'auto'}}>
          <table style={{width:'100%',borderCollapse:'collapse',minWidth:680}}>
            <thead><tr style={{borderBottom:'1px solid #eef0f3'}}>
              {['Cliente','Teléfono','Cédula / RUC','Temperatura','Estado','Acciones'].map(h=>(
                <th key={h} style={{padding:'10px 14px',fontSize:10,fontWeight:700,color:'#94a3b8',textAlign:'left'}}>{h}</th>
              ))}
            </tr></thead>
            <tbody>
              {pgC.paged.map((c,i)=>{
                const heatCfg = {caliente:{c:'#ef4444',bg:'#fff5f5',l:'🔥 Caliente'},tibio:{c:'#f59e0b',bg:'#fffbeb',l:'🌡️ Tibio'},frio:{c:'#4f6ef7',bg:'#f0f1ff',l:'❄️ Frío'}}[c.heat||'tibio']||{c:'#94a3b8',bg:'#f1f5f9',l:'—'};
                return(
                  <tr key={i} style={{borderTop:'1px solid #f8fafc',cursor:'pointer'}} onClick={()=>setDetail(c)}>
                    <td style={{padding:'10px 14px'}}>
                      <div style={{fontSize:13,fontWeight:700,color:'var(--dark,#0f172a)'}}>{c.name}</div>
                      <div style={{fontSize:11,color:'#94a3b8'}}>{c.email||c.phone}</div>
                    </td>
                    <td style={{padding:'10px 14px',fontSize:12,color:'#64748b'}}>{c.phone}</td>
                    <td style={{padding:'10px 14px',fontSize:12,color:'#64748b'}}>{c.cedula||c.metadata?.cedula||'—'}</td>
                    <td style={{padding:'10px 14px'}}>
                      <span style={{background:heatCfg.bg,color:heatCfg.c,padding:'3px 9px',borderRadius:6,fontSize:11,fontWeight:700}}>{heatCfg.l}</span>
                    </td>
                    <td style={{padding:'10px 14px'}}>
                      {c.result==='won'  && <span style={{color:'#10b981',fontWeight:700,fontSize:12}}>✓ Ganado</span>}
                      {c.result==='lost' && <span style={{color:'#ef4444',fontWeight:700,fontSize:12}}>✗ Perdido</span>}
                      {!c.result         && <span style={{color:'#f59e0b',fontWeight:700,fontSize:12}}>● En proceso</span>}
                    </td>
                    <td style={{padding:'10px 14px'}} onClick={e=>e.stopPropagation()}>
                      <div style={{display:'flex',gap:5,flexWrap:'wrap'}}>
                        <button onClick={()=>openEdit(c)} style={{padding:'4px 9px',borderRadius:6,border:'none',background:'#eef2ff',color:p,fontWeight:700,fontSize:11,cursor:'pointer',display:'flex',alignItems:'center',gap:3}}>
                          <Edit2 size={10}/> Editar
                        </button>
                        {!c.result&&<button onClick={()=>setWinModal(c)} style={{padding:'4px 9px',borderRadius:6,border:'none',background:'#d1fae5',color:'#10b981',fontWeight:700,fontSize:11,cursor:'pointer'}}>Ganado</button>}
                        {!c.result&&<button onClick={()=>setLossModal(c)} style={{padding:'4px 9px',borderRadius:6,border:'none',background:'#fef2f2',color:'#ef4444',fontWeight:700,fontSize:11,cursor:'pointer'}}>Perdido</button>}
                        {c.result&&<button onClick={()=>reabrir(c)} style={{padding:'4px 9px',borderRadius:6,border:'none',background:'#f1f5f9',color:'#64748b',fontWeight:700,fontSize:11,cursor:'pointer',display:'flex',alignItems:'center',gap:3}}><RefreshCw size={10}/> Reabrir</button>}
                        <button onClick={()=>setSendModal(c)} style={{padding:'4px 9px',borderRadius:6,border:'none',background:'#f0fdf9',color:'#059669',fontWeight:700,fontSize:11,cursor:'pointer',display:'flex',alignItems:'center',gap:3}}>
                          <MessageCircle size={10}/> WA
                        </button>
                        <button onClick={()=>eliminar(c)} style={{padding:'4px 9px',borderRadius:6,border:'none',background:'#fef2f2',color:'#ef4444',fontWeight:700,fontSize:11,cursor:'pointer',display:'flex',alignItems:'center',gap:3}}>
                          <Trash2 size={10}/>
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
              {filteredC.length===0&&<tr><td colSpan={6} style={{padding:24,textAlign:'center',color:'#94a3b8',fontSize:12}}>Sin clientes asignados a ti</td></tr>}
            </tbody>
          </table>
          <div style={{padding:'0 14px'}}><Pagination {...pgC} primary={p} label="clientes" /></div>
        </div>
      ) : tab==='leads' ? (
        <div style={{background:'var(--card-bg,#fff)',borderRadius:16,border:'1px solid #e5e7eb',overflowX:'auto'}}>
          <table style={{width:'100%',borderCollapse:'collapse',minWidth:680}}>
            <thead><tr style={{borderBottom:'1px solid #eef0f3'}}>
              {['Lead','Teléfono','Cédula','Nivel','Score','Canal','Fecha','Contacto'].map(h=>(
                <th key={h} style={{padding:'10px 14px',fontSize:10,fontWeight:700,color:'#94a3b8',textAlign:'left'}}>{h}</th>
              ))}
            </tr></thead>
            <tbody>
              {pgL.paged.map((l,i)=>{
                const nc={caliente:{c:'#ef4444',b:'#fff5f5'},tibio:{c:'#f59e0b',b:'#fffbeb'},frio:{c:'#4f6ef7',b:'#f0f1ff'}}[l.nivel]||{c:'#94a3b8',b:'#f1f5f9'};
                const contactado=!!l.metadata?.asesor_contacto;
                return(
                  <tr key={i} style={{borderTop:'1px solid #f8fafc'}}>
                    <td style={{padding:'10px 14px',fontSize:13,fontWeight:700,color:'var(--dark,#0f172a)'}}>{l.nombre}</td>
                    <td style={{padding:'10px 14px',fontSize:12,color:'#64748b'}}>{l.telefono}</td>
                    <td style={{padding:'10px 14px',fontSize:12,color:'#64748b'}}>{l.cedula||l.metadata?.cedula||'—'}</td>
                    <td style={{padding:'10px 14px'}}><span style={{background:nc.b,color:nc.c,padding:'2px 8px',borderRadius:6,fontSize:11,fontWeight:700,textTransform:'capitalize'}}>{l.nivel}</span></td>
                    <td style={{padding:'10px 14px',fontSize:12,fontWeight:700,color:'var(--dark,#0f172a)'}}>{l.score}/100</td>
                    <td style={{padding:'10px 14px',fontSize:11,color:'#64748b'}}>{l.canal||'WhatsApp'}</td>
                    <td style={{padding:'10px 14px',fontSize:11,color:'#94a3b8'}}>{l.created_at?new Date(l.created_at).toLocaleDateString('es-EC'):'—'}</td>
                    <td style={{padding:'10px 14px'}}>
                      {contactado
                        ? <span style={{fontSize:10,fontWeight:700,color:'#059669',background:'#f0fdf4',padding:'2px 8px',borderRadius:999,whiteSpace:'nowrap'}}>✓ Contactado</span>
                        : <span style={{fontSize:10,fontWeight:700,color:'#94a3b8',background:'#f1f5f9',padding:'2px 8px',borderRadius:999,whiteSpace:'nowrap'}}>Sin contactar</span>}
                    </td>
                  </tr>
                );
              })}
              {filteredL.length===0&&<tr><td colSpan={8} style={{padding:24,textAlign:'center',color:'#94a3b8',fontSize:12}}>Sin leads asignados a ti</td></tr>}
            </tbody>
          </table>
          <div style={{padding:'0 14px'}}><Pagination {...pgL} primary={p} label="leads" /></div>
        </div>
      ) : (
        <TabConversaciones leads={leads} initial={null} />
      )}

      {/* Modal detalle de cliente + reasignar asesor */}
      {detail && (
        <MiClienteDetalle
          client={detail}
          asesores={asesores}
          onClose={()=>setDetail(null)}
          onEditar={openEdit}
          onVerConversacion={onVerConversacion}
          onReasignado={(id,nombreAsesor)=>{
            setClients(prev=>prev.filter(x=>x.id!==id));
            alert(`✅ Cliente reasignado${nombreAsesor?' a '+nombreAsesor:''}.`);
          }}
        />
      )}
    </div>
  );
}

/* ════════════════════════════════════════════════════════════════════
   TAB ACTIVIDADES SUPERVISOR — registro personal de actividades
═══════════════════════════════════════════════════════════════════ */
function TabActividadesSupervisor({ clients }) {
  const p = DS.primary;
  const TIPOS = {
    llamada:       { l:'Llamada',     c:DS.primary, Icon:Phone          },
    reunion:       { l:'Reunión',     c:'#8b5cf6', Icon:Users          },
    email:         { l:'Email',       c:'#f59e0b', Icon:MessageSquare  },
    visita:        { l:'Visita',      c:'#10b981', Icon:Target         },
    nota:          { l:'Nota',        c:'#64748b', Icon:FileText       },
    cita:          { l:'Cita',        c:'#8b5cf6', Icon:Calendar       },
  };
  const [acts, setActs]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [form, setForm]   = useState({ clientId:'', type:'llamada', resultado:'', notas:'', duration:'' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    apiFetch('GET', '/api/supervisor/my-activities')
      .then(r => { setActs(Array.isArray(r)?r:[]); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  async function registrar() {
    if (!form.notas.trim()) return alert('Escribe una nota o resultado');
    setSaving(true);
    try {
      const r = await apiFetch('POST', '/api/supervisor/my-activities', {
        ...form, duration: parseInt(form.duration)||0
      });
      setActs(prev => [r, ...prev]);
      setModal(false);
      setForm({ clientId:'', type:'llamada', resultado:'', notas:'', duration:'' });
    } catch(e) { alert('Error: ' + e.message); }
    setSaving(false);
  }

  const inp = { width:'100%', padding:'9px 12px', border:'1px solid #e2e8f0', borderRadius:9, fontSize:13, outline:'none', boxSizing:'border-box' };

  return (
    <div>
      {modal && (
        <div style={{position:'fixed',inset:0,background:'rgba(15,23,42,0.5)',backdropFilter:'blur(4px)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}>
          <div style={{background:'#fff',borderRadius:20,padding:28,width:460,boxShadow:'0 24px 60px rgba(0,0,0,0.2)'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:18}}>
              <h3 style={{margin:0,fontSize:17,fontWeight:800,color:'var(--dark,#0f172a)'}}>Registrar actividad</h3>
              <button onClick={()=>setModal(false)} style={{border:'none',background:'#f1f5f9',borderRadius:8,padding:7,cursor:'pointer',display:'flex'}}><X size={14} color="#64748b"/></button>
            </div>
            <div style={{display:'flex',flexDirection:'column',gap:10,marginBottom:16}}>
              <div>
                <div style={{fontSize:10,color:'#94a3b8',fontWeight:700,marginBottom:6}}>TIPO DE ACTIVIDAD</div>
                <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                  {Object.entries(TIPOS).map(([k,v])=>(
                    <button key={k} onClick={()=>setForm(x=>({...x,type:k}))}
                      style={{padding:'7px 12px',borderRadius:8,border:`2px solid ${form.type===k?v.c:'#e2e8f0'}`,background:form.type===k?`${v.c}12`:'#fff',color:form.type===k?v.c:'#94a3b8',fontWeight:700,fontSize:11,cursor:'pointer'}}>
                      {v.l}
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <div style={{fontSize:10,color:'#94a3b8',fontWeight:700,marginBottom:4}}>CLIENTE (OPCIONAL)</div>
                <select value={form.clientId} onChange={e=>setForm(x=>({...x,clientId:e.target.value}))} style={{...inp,cursor:'pointer'}}>
                  <option value=''>Sin cliente específico</option>
                  {(clients||[]).map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
                </select>
              </div>
              <div>
                <div style={{fontSize:10,color:'#94a3b8',fontWeight:700,marginBottom:4}}>RESULTADO</div>
                <input value={form.resultado} onChange={e=>setForm(x=>({...x,resultado:e.target.value}))} placeholder="Ej: Acordó reunión para la próxima semana" style={inp}/>
              </div>
              <div>
                <div style={{fontSize:10,color:'#94a3b8',fontWeight:700,marginBottom:4}}>NOTAS *</div>
                <textarea value={form.notas} onChange={e=>setForm(x=>({...x,notas:e.target.value}))} rows={3} placeholder="Describe lo que ocurrió..." style={{...inp,resize:'none'}}/>
              </div>
              <div>
                <div style={{fontSize:10,color:'#94a3b8',fontWeight:700,marginBottom:4}}>DURACIÓN (minutos)</div>
                <input type="number" value={form.duration} onChange={e=>setForm(x=>({...x,duration:e.target.value}))} placeholder="0" style={{...inp,width:'30%'}}/>
              </div>
            </div>
            <div style={{display:'flex',gap:10}}>
              <button onClick={()=>setModal(false)} style={{flex:1,padding:'10px',borderRadius:10,border:'1px solid #e2e8f0',background:'#f8fafc',color:'#64748b',fontWeight:700,cursor:'pointer'}}>Cancelar</button>
              <button onClick={registrar} disabled={saving} style={{flex:2,padding:'10px',borderRadius:10,border:'none',background:p,color:'#fff',fontWeight:700,cursor:'pointer'}}>
                {saving?'Guardando...':'✓ Registrar'}
              </button>
            </div>
          </div>
        </div>
      )}

      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20}}>
        <div>
          <h1 style={{margin:0,fontSize:MOB?22:28,fontWeight:800,color:NAVY,letterSpacing:'-0.5px'}}>Mis Actividades</h1>
        </div>
        <button onClick={()=>setModal(true)} style={{padding:'10px 18px',borderRadius:10,border:'none',background:p,color:'#fff',fontWeight:700,fontSize:13,cursor:'pointer',display:'flex',alignItems:'center',gap:7}}>
          <Plus size={14}/> Registrar actividad
        </button>
      </div>

      {/* Resumen */}
      <div style={{display:'grid',gridTemplateColumns:MOB?'repeat(2,1fr)':'repeat(4,1fr)',gap:12,marginBottom:20}}>
        {Object.entries(TIPOS).slice(0,4).map(([k,v])=>{
          const cnt = acts.filter(a=>a.type===k).length;
          return(
            <div key={k} style={{background:'var(--card-bg,#fff)',borderRadius:14,padding:'16px',border:'1px solid #e5e7eb'}}>
              <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:8}}>
                {v.Icon && <v.Icon size={16} color={v.c}/>}
                <span style={{fontSize:11,fontWeight:700,color:v.c,textTransform:'uppercase',letterSpacing:0.5}}>{v.l}</span>
              </div>
              <div style={{fontSize:28,fontWeight:800,color:v.c,lineHeight:1}}>{cnt}</div>
            </div>
          );
        })}
      </div>

      {/* Lista */}
      <div style={{background:'var(--card-bg,#fff)',borderRadius:16,border:'1px solid #e5e7eb',overflow:'hidden'}}>
        {loading && <div style={{padding:32,textAlign:'center',color:'#94a3b8'}}>Cargando...</div>}
        {!loading && acts.length===0 && <div style={{padding:32,textAlign:'center',color:'#94a3b8'}}>Sin actividades registradas. ¡Registra tu primera!</div>}
        {acts.map((a,i)=>{
          const t = TIPOS[a.type]||TIPOS.nota;
          return(
            <div key={a.id||i} style={{display:'flex',gap:14,padding:'14px 20px',borderBottom:'1px solid #f8fafc',alignItems:'flex-start'}}>
              <div style={{width:38,height:38,borderRadius:10,background:`${t.c}12`,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                {t.Icon && <t.Icon size={16} color={t.c} strokeWidth={2}/>}
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:3}}>
                  <span style={{fontSize:13,fontWeight:700,color:'var(--dark,#0f172a)'}}>{t.l}{a.client_name?` — ${a.client_name}`:''}</span>
                  <span style={{fontSize:11,color:'#94a3b8'}}>{a.created_at?new Date(a.created_at).toLocaleString('es-EC',{day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'}):''}</span>
                </div>
                {a.resultado&&<div style={{fontSize:12,color:t.c,fontWeight:600,marginBottom:2}}>Resultado: {a.resultado}</div>}
                {a.notas&&<div style={{fontSize:12,color:'#64748b',lineHeight:1.5}}>{a.notas}</div>}
                {a.duration>0&&<div style={{fontSize:11,color:'#94a3b8',marginTop:3}}>⏱ {a.duration} min</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* ════════════════════════════════════════════════════════════════════
   TAB ACTIVIDADES EQUIPO — ve lo que hace todo el equipo
═══════════════════════════════════════════════════════════════════ */
function TabActividadesEquipo({ asesores }) {
  const p = DS.primary;
  const TIPOS = {
    llamada:       { l:'Llamada',          c:DS.primary, Icon:Phone          },
    reunion:       { l:'Reunión',          c:'#8b5cf6', Icon:Users          },
    email:         { l:'Email',            c:'#f59e0b', Icon:MessageSquare  },
    visita:        { l:'Visita',           c:'#10b981', Icon:Target         },
    nota:          { l:'Nota',             c:'#64748b', Icon:FileText       },
    mensaje_wa:    { l:'Mensaje WA',       c:'#25d366', Icon:MessageCircle  },
    whatsapp:      { l:'WhatsApp',         c:'#25d366', Icon:MessageCircle  },
    cambio_estado: { l:'Cambio de estado', c:'#ef4444', Icon:RefreshCw      },
    cita:          { l:'Cita',             c:'#8b5cf6', Icon:Calendar       },
    reasignacion:  { l:'Reasignación',     c:'#2563eb', Icon:UserCheck      },
    venta:         { l:'Venta',            c:'#10b981', Icon:CheckCircle    },
  };
  const [acts,    setActs]    = useState([]);
  const [roster,  setRoster]  = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro,  setFiltro]  = useState('all');
  const [filtroT, setFiltroT] = useState('all');

  useEffect(() => {
    Promise.all([
      apiFetch('GET', '/api/supervisor/team-activities').then(r => Array.isArray(r)?r:[]).catch(() => []),
      apiFetch('GET', '/api/supervisor/asesores').then(r => Array.isArray(r)?r:[]).catch(() => []),
    ]).then(([a, ro]) => { setActs(a); setRoster(ro); setLoading(false); });
  }, []);

  // ponytail: roster union activities — el DELETE semanal vacía activities, así que la lista de asesores sale del roster (users), no de las actividades
  const asesorNombres = [...new Set([...roster.map(u=>u.name), ...acts.map(a=>a.advisor_name)].filter(Boolean))];
  const filtered = acts.filter(a =>
    (filtro==='all' || a.advisor_name===filtro) &&
    (filtroT==='all' || a.type===filtroT)
  );

  const byAsesor = asesorNombres.map(n=>({
    name: n,
    total: acts.filter(a=>a.advisor_name===n).length,
    hoy:   acts.filter(a=>a.advisor_name===n && new Date(a.created_at).toDateString()===new Date().toDateString()).length,
  }));

  return (
    <div>
      <div style={{marginBottom:20}}>
        <h1 style={{margin:0,fontSize:MOB?22:28,fontWeight:800,color:NAVY,letterSpacing:'-0.5px'}}>Actividades del Equipo</h1>
        <p style={{margin:'4px 0 0',fontSize:14,color:'#64748b'}}>Todo lo que registra tu equipo de asesores</p>
      </div>

      {/* Resumen por asesor */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))',gap:12,marginBottom:20}}>
        {byAsesor.map((a,i)=>(
          <div key={i}
            onClick={()=>setFiltro(filtro===a.name?'all':a.name)}
            style={{background:'#fff',borderRadius:14,padding:'16px',border:`2px solid ${filtro===a.name?p:'#eaecf0'}`,cursor:'pointer',transition:'all .2s',boxShadow:filtro===a.name?`0 6px 20px ${p}20`:'none'}}>
            <div style={{width:36,height:36,borderRadius:'50%',background:`${p}15`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:14,fontWeight:800,color:p,marginBottom:10}}>{a.name?.charAt(0)?.toUpperCase()}</div>
            <div style={{fontSize:14,fontWeight:800,color:'var(--dark,#0f172a)'}}>{a.name?.split(' ')[0]}</div>
            <div style={{fontSize:12,color:'#94a3b8',marginTop:2}}>{a.total} actividades · {a.hoy} hoy</div>
          </div>
        ))}
        {byAsesor.length===0&&!loading&&<div style={{gridColumn:'1/-1',padding:'24px',textAlign:'center',color:'#94a3b8',fontSize:13}}>Sin actividades registradas por el equipo</div>}
      </div>

      {/* Filtros */}
      <div style={{display:'flex',gap:8,marginBottom:16,flexWrap:'wrap'}}>
        <button onClick={()=>setFiltro('all')} style={{padding:'6px 14px',borderRadius:8,border:'none',fontSize:12,fontWeight:700,cursor:'pointer',background:filtro==='all'?NAVY:'#fff',color:filtro==='all'?'#fff':'#475569',boxShadow:'inset 0 0 0 1px #e5e7eb'}}>Todos</button>
        {asesorNombres.map(n=>(
          <button key={n} onClick={()=>setFiltro(filtro===n?'all':n)} style={{padding:'6px 14px',borderRadius:8,border:'none',fontSize:12,fontWeight:700,cursor:'pointer',background:filtro===n?NAVY:'#fff',color:filtro===n?'#fff':'#475569',boxShadow:'inset 0 0 0 1px #e5e7eb'}}>{n.split(' ')[0]}</button>
        ))}
        <div style={{height:1,width:'100%'}}/>
        {['all',...Object.keys(TIPOS)].map(k=>{
          const t = k==='all'?{l:'Todos los tipos',c:'#64748b'}:TIPOS[k];
          return <button key={k} onClick={()=>setFiltroT(k)} style={{padding:'6px 14px',borderRadius:8,border:'none',fontSize:11,fontWeight:700,cursor:'pointer',background:filtroT===k?t.c:'#f1f5f9',color:filtroT===k?'#fff':'#64748b'}}>{k==='all'?'Todos':t.l}</button>;
        })}
      </div>

      {/* Lista */}
      <div style={{background:'var(--card-bg,#fff)',borderRadius:16,border:'1px solid #e5e7eb',overflow:'hidden'}}>
        {loading && <div style={{padding:32,textAlign:'center',color:'#94a3b8'}}>Cargando actividades...</div>}
        {!loading && filtered.length===0 && <div style={{padding:32,textAlign:'center',color:'#94a3b8'}}>Sin actividades con los filtros actuales</div>}
        {filtered.map((a,i)=>{
          const t = TIPOS[a.type]||TIPOS.nota;
          return(
            <div key={a.id||i} style={{display:'flex',gap:14,padding:'14px 20px',borderBottom:'1px solid #f8fafc',alignItems:'flex-start'}}>
              <div style={{width:38,height:38,borderRadius:10,background:`${t.c}12`,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                {t.Icon && <t.Icon size={16} color={t.c} strokeWidth={2}/>}
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:3}}>
                  <div>
                    <span style={{fontSize:13,fontWeight:700,color:'var(--dark,#0f172a)'}}>{t.l}</span>
                    {a.client_name&&<span style={{fontSize:12,color:'#94a3b8'}}> · {a.client_name}</span>}
                  </div>
                  <div style={{textAlign:'right',flexShrink:0}}>
                    <div style={{fontSize:11,color:'#94a3b8'}}>{a.created_at?new Date(a.created_at).toLocaleString('es-EC',{day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'}):''}</div>
                    <div style={{fontSize:11,fontWeight:700,color:p}}>{a.advisor_name}</div>
                  </div>
                </div>
                {a.resultado&&<div style={{fontSize:12,color:t.c,fontWeight:600,marginBottom:2}}>↳ {a.resultado}</div>}
                {a.notas&&<div style={{fontSize:12,color:'#64748b',lineHeight:1.5}}>{a.notas}</div>}
                {a.duration>0&&<div style={{fontSize:11,color:'#94a3b8',marginTop:3}}>⏱ {a.duration} min</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default function DashboardSupervisor({user,currentView,onNavigate,primary=DS.primary,pageBg='#f0f4ff',cardBg='#ffffff',cardBorder,cardShadow}) {
  DS = makeDS(primary);
  SUP = user || null;
  CB = cardBg || '#ffffff'; // update module-level for sub-components
  CBorder = cardBorder || `${primary}20`;
  CShadow = cardShadow || `0 2px 12px ${primary}14`;
  MOB = window.innerWidth < 768;
  syncAdminTheme(primary); // Inicio/Pipeline vienen del panel admin
  const [clients,  setClients]  = React.useState([]);
  const [events,   setEvents]   = React.useState([]);
  const [leads,    setLeads]    = React.useState([]);
  const [asesores, setAsesores] = React.useState([]);
  const [stats,    setStats]    = React.useState(null);
  const [users,    setUsers]    = React.useState([]);
  const [selectedContact, setSelectedContact] = React.useState(null);
  const [confirmDlg, setConfirmDlg] = React.useState(null);
  const [teamActivities, setTeamActivities] = React.useState([]);
  const [convInitial, setConvInitial] = React.useState(null);
  const [clientInitial, setClientInitial] = React.useState(null);
  _setConfirmS = setConfirmDlg;

  const nav  = onNavigate || (() => {});
  const view = currentView || 'dashboard';

  // Al hacer clic en una notificación → abrir la ficha del cliente
  React.useEffect(() => {
    const h = (e) => {
      const d = e.detail || {};
      const digits = String(d.phone||'').replace(/\D/g,'');
      const cli = clients.find(c => {
        const cd = String(c.phone||'').replace(/\D/g,'');
        return (digits && cd && cd.slice(-9) === digits.slice(-9)) || (d.name && c.name === d.name);
      });
      if (cli) { setClientInitial(cli); nav('clients'); }
      else alert('Este cliente no está en la cartera.');
    };
    window.addEventListener('crm:open-client', h);
    return () => window.removeEventListener('crm:open-client', h);
  }, [clients, nav]);

  // Ver conversación del bot con un cliente: busca su lead por teléfono y navega
  function verConversacionCliente(client) {
    const digits = String(client?.phone||'').replace(/\D/g,'');
    const lead = leads.find(l => {
      const ld = String(l.telefono||l.phone||'').replace(/\D/g,'');
      return ld && digits && ld.slice(-9) === digits.slice(-9);
    });
    if (!lead) { alert('Este cliente aún no tiene una conversación con el bot.'); return; }
    setConvInitial(lead);
    nav('conversaciones');
  }

  const cargar = useCallback(async () => {
    // Cada respuesta se pinta en cuanto llega (antes Promise.all esperaba a la más lenta)
    const err = e => console.error('Error cargando datos supervisor:', e.message);
    await Promise.all([
      apiFetch('GET','/api/supervisor/stats').then(statsRes => {
        if (statsRes) setStats(statsRes);
      }).catch(err),
      apiFetch('GET','/api/supervisor/clients?limit=100000000').then(clientsRes => {
        if (Array.isArray(clientsRes) && clientsRes.length>0) {
        setClients(clientsRes.map(c=>({...c, result:c.metadata?.result||null, heat:c.metadata?.heat||c.heat||'tibio', producto:c.metadata?.producto||c.producto||'', cedula:c.metadata?.cedula||c.cedula||'', asesor:c.advisor_name||c.asesor||'', asesorId:c.assigned_advisor_id||''})));
      }
      }).catch(err),
      apiFetch('GET','/api/supervisor/asesores').then(asesoresRes => {
        if (Array.isArray(asesoresRes) && asesoresRes.length>0) {
        setAsesores(asesoresRes.map(a=>({...a, active:a.status==='active', score:Math.min(100,Math.round(((parseInt(a.ganados)||0)/Math.max(parseInt(a.total_clients)||1,1))*100+50)), clients:parseInt(a.total_clients)||0, won:parseInt(a.ganados)||0, lost:parseInt(a.perdidos)||0})));
      }
      }).catch(err),
      apiFetch('GET','/api/supervisor/leads').then(leadsRes => {
        if (Array.isArray(leadsRes) && leadsRes.length>0) {
        setLeads(leadsRes.map(l=>({...l, nivel:l.nivel||'tibio', score:l.score||50, msgBot:l.msg_bot||'', cedula:l.metadata?.cedula||l.cedula||'', asesor:l.advisor_name||'Sin asignar', asesorId:l.advisor_id||'', fecha:l.created_at})));
      }
      }).catch(err),
      apiFetch('GET','/api/supervisor/contacts').then(contactsRes => {
        if (Array.isArray(contactsRes) && contactsRes.length>0) setUsers(contactsRes);
      }).catch(err),
      apiFetch('GET','/api/supervisor/calendar').then(calRes => {
        if (Array.isArray(calRes) && calRes.length>0) {
        setEvents(calRes.map(e=>{
          const notes = e.notes||'';
          const nl = notes.indexOf('\n');
          const title = (nl>=0 ? notes.slice(0,nl) : notes) || (e.type||'Evento');
          const description = nl>=0 ? notes.slice(nl+1) : '';
          return {...e, date:e.event_date, time:e.event_time||'', cname:e.client_name||'—',
            title, clientName:e.client_name||'', description, asesorId:'', asesor:''};
        }));
      }
      }).catch(err),
      apiFetch('GET','/api/supervisor/team-activities').then(teamActRes => {
        if (Array.isArray(teamActRes)) setTeamActivities(teamActRes);
      }).catch(err),
    ]);
  }, []);

  useEffect(() => { cargar(); }, [cargar]);
  // Inicio/Pipeline del admin esperan users con role/status; el supervisor también recibe leads del reparto
  const equipo = React.useMemo(() => [...asesores.map(a => ({ ...a, role:'advisor' })),
    ...(user?.id ? [{ ...user, role:'supervisor', status:'active' }] : [])], [asesores, user]);

  return (
    <>
      {view === 'dashboard' && <InicioAdmin user={user} users={equipo} leads={leads} clients={clients} onNavigate={nav}/>}
      {view === 'clients'   && <><PageHead title="Clientes" sub="Clientes del equipo · toca uno para ver el detalle"/><TabClientes   clients={clients} setClients={setClients} asesores={asesores} leads={leads} onVerConversacion={(lead)=>{ setConvInitial(lead); nav('conversaciones'); }} initialClient={clientInitial} onInitialDone={()=>setClientInitial(null)} /></>}
      {view === 'advisors'  && <><PageHead title="Asesores" sub="Tu equipo de ventas y su actividad"/><TabAsesores   clients={clients} asesores={asesores} teamActivities={teamActivities} onNavigate={nav} onSelectContact={setSelectedContact} /></>}
      {view === 'sales'     && <TabVentas     clients={clients} asesores={asesores} />}
      {view === 'messages'  && <><PageHead title="Mensajes" sub="Chat interno con el equipo"/><TabMensajes   users={users} initialContact={selectedContact} /></>}
      {view === 'reports'   && <><PageHead title="Reportes" sub="Resumen y exportación de la actividad del equipo"/><TabReportes   clients={clients} asesores={asesores} teamActivities={teamActivities} /></>}
      {view === 'calendar'  && <><PageHead title="Calendario" sub="Citas y seguimientos del equipo"/><TabCalendario events={events} setEvents={setEvents} asesores={asesores} /></>}
      {(view === 'pipeline' || view === 'leads') && <TabPipelineAdmin leads={leads} setLeads={setLeads} clients={clients} users={equipo} me={user}/>}
      {view === 'mis_clientes'       && <><PageHead title="Mis clientes" sub="Tus clientes, leads y conversaciones"/><TabMisClientes user={user} onVerConversacion={verConversacionCliente}/></>}
      {view === 'estadisticas'       && <TabEstadisticasPersonales stats={stats} leads={leads} clients={clients} events={events} onNavigate={nav}/>}
      {view === 'rendimiento_equipo' && <><PageHead title="Rendimiento del equipo" sub="Clientes, ventas y conversión por asesor"/><TabRendimientoEquipo clients={clients} asesores={asesores} leads={leads} teamActivities={teamActivities}/></>}
      {view === 'conversaciones'     && <><PageHead title="Conversaciones" sub="Chats del bot de WhatsApp con cada lead"/><TabConversaciones leads={leads} initial={convInitial}/></>}
      {view === 'mis_actividades'    && <TabActividadesSupervisor clients={clients}/>}
      {view === 'actividades_equipo' && <TabActividadesEquipo asesores={asesores}/>}
      {confirmDlg&&<ConfirmModal msg={confirmDlg.msg} onYes={confirmDlg.onYes} onClose={()=>setConfirmDlg(null)}/>}
    </>
  );
}
